<style>
@import url("https://stackpath.bootstrapcdn.com/bootstrap/4.1.3/css/bootstrap.min.css");
</style>
<template>
  <ScrollProgressBar :color="'matthias-red'">
    <div class="main-container project matthias">
      <Menu
        :hamburgerColor="this.activeSectionMenuColor"
        :showChild="showChild"
        :title="sections[activeSectionTitle].title"
        :dot="sections[activeSectionTitle].dot"
        :textColor="sections[activeSectionTitle].textColor"
        :agency="sections[activeSectionTitle].agency"
        :client="sections[activeSectionTitle].client"
        :role="sections[activeSectionTitle].role"
        :url="sections[activeSectionTitle].url"
        :subtitle="sections[activeSectionTitle].subtitle"
        :specificationColor="sections[activeSectionTitle].specificationColor"
        @changeActiveSection="activeSection = $event"
        class="fixed-top matthias"
      />

      <!-- First section -->
      <section class="section__project intro">
        <div class="main-container__logo white fixed-top">
          <div>
            <router-link to="/" aria-label="intervi logo">
              <svg
                width="109px"
                height="19px"
                viewBox="0 0 109 19"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <defs>
                  <polygon
                    id="path-1"
                    points="0 0.385902439 5.90810769 0.385902439 5.90810769 17.9477561 0 17.9477561"
                  />
                  <polygon
                    id="path-3"
                    points="0.000230769231 0.325714286 17.7233077 0.325714286 17.7233077 17.9491286 0.000230769231 17.9491286"
                  />
                  <polygon
                    id="path-5"
                    points="0.0345857143 0.335813953 17.8631571 0.335813953 17.8631571 18.9998674 0.0345857143 18.9998674"
                  />
                  <polygon
                    id="path-7"
                    points="0.35506875 0.03138 5.8695 0.03138 5.8695 5.91358 0.35506875 5.91358"
                  />
                </defs>
                <g
                  id="Page-1"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <g
                    id="NEW-NEW-contact"
                    transform="translate(-276.000000, -56.000000)"
                  >
                    <g
                      id="Group-21"
                      transform="translate(276.000000, 56.000000)"
                    >
                      <g id="Group-3">
                        <mask id="mask-2" fill="white">
                          <use xlink:href="#path-1" />
                        </mask>
                        <g id="Clip-2" />
                        <path
                          d="M5.90810769,0.859170732 L5.90810769,17.4744878 C5.90810769,17.7357073 5.68564615,17.9477561 5.41056923,17.9477561 L0.497492308,17.9477561 C0.222876923,17.9477561 -4.61538462e-05,17.7357073 -4.61538462e-05,17.4744878 L-4.61538462e-05,0.859170732 C-4.61538462e-05,0.597512195 0.222876923,0.385902439 0.497492308,0.385902439 L5.41056923,0.385902439 C5.68564615,0.385902439 5.90810769,0.597512195 5.90810769,0.859170732"
                          id="Fill-1"
                          fill="#000000"
                          mask="url(#mask-2)"
                        />
                      </g>
                      <g id="Group-6" transform="translate(9.000000, 0.000000)">
                        <mask id="mask-4" fill="white">
                          <use xlink:href="#path-3" />
                        </mask>
                        <g id="Clip-5" />
                        <path
                          d="M17.7233077,7.42298571 L17.7233077,17.4867 C17.7233077,17.7421286 17.5008462,17.9491286 17.2257692,17.9491286 L12.6823846,17.9491286 C12.4073077,17.9491286 12.1848462,17.7421286 12.1848462,17.4867 L12.1848462,8.17727143 C12.1848462,6.05112857 10.7448462,5.05684286 8.97253846,5.05684286 C6.94176923,5.05684286 5.53869231,6.15398571 5.53869231,8.5887 L5.53869231,17.4867 C5.53869231,17.7421286 5.31576923,17.9491286 5.04069231,17.9491286 L0.497769231,17.9491286 C0.222692308,17.9491286 0.000230769231,17.7421286 0.000230769231,17.4867 L0.000230769231,1.26741429 C0.000230769231,1.01198571 0.222692308,0.805414286 0.497769231,0.805414286 L5.04069231,0.805414286 C5.31576923,0.805414286 5.53869231,1.01198571 5.53869231,1.26741429 C5.53869231,1.65227143 6.02146154,1.87512857 6.34130769,1.62955714 C7.39961538,0.8187 8.93192308,0.325414286 10.8186923,0.325414286 C14.5479231,0.325414286 17.7233077,2.79398571 17.7233077,7.42298571"
                          id="Fill-4"
                          fill="#000000"
                          mask="url(#mask-4)"
                        />
                      </g>
                      <path
                        d="M36.9355129,1 L38.7299651,5.47259445 C38.8571375,5.79056622 38.6420179,6.14515833 38.3211967,6.14515833 L36.0428287,6.14515833 C35.7967419,6.14515833 35.5977253,6.36086109 35.5977253,6.62702846 L35.5977253,12.4693131 C35.5977253,13.892594 36.6477234,14.1199081 38.5367291,14.0314834 C38.7885965,14.0194255 39,14.2395941 39,14.5120137 L39,18.4250315 C39,18.6737819 38.8216283,18.8845721 38.5924703,18.906455 C32.4460794,19.487468 30.6429563,17.3643813 30.6429563,12.4693131 L30.6429563,6.62702846 C30.6429563,6.36086109 30.4435269,6.14515833 30.1978529,6.14515833 L28.4455163,6.14515833 C28.1994295,6.14515833 28,5.92990216 28,5.66373478 L28,1"
                        id="Fill-7"
                        fill="#000000"
                      />
                      <g
                        id="Group-11"
                        transform="translate(41.000000, 0.000000)"
                      >
                        <mask id="mask-6" fill="white">
                          <use xlink:href="#path-5" />
                        </mask>
                        <g id="Clip-10" />
                        <path
                          d="M12.0975857,7.82963488 C12.4391571,7.82963488 12.6564429,7.46244884 12.5137286,7.1421 C11.8327286,5.61105349 10.4763,5.0375186 9.1203,5.0375186 C7.43001429,5.0375186 6.22744286,5.77675116 5.62272857,7.14254186 C5.48087143,7.4628907 5.69687143,7.82963488 6.03844286,7.82963488 L12.0975857,7.82963488 Z M9.6003,14.2635651 C10.8615857,14.2635651 11.9574429,13.808007 12.6641571,13.1527279 C12.8098714,13.0175186 13.0241571,12.9985186 13.1943,13.0997047 L16.5487286,15.0880767 C16.7908714,15.2312395 16.8615857,15.5674953 16.6850143,15.7910767 C15.0101571,17.9106814 12.5878714,18.9998674 9.53172857,18.9998674 C3.66844286,18.9998674 0.0345857143,14.935193 0.0345857143,9.66777442 C0.0345857143,4.40035581 3.73701429,0.335681395 9.15458571,0.335681395 C14.1598714,0.335681395 17.8631571,4.3301 17.8631571,9.66777442 C17.8631571,10.2682628 17.8185857,10.8448907 17.7290143,11.3985419 C17.6921571,11.6256581 17.4954429,11.7887047 17.2717286,11.7887047 L6.22272857,11.7887047 C5.86187143,11.7887047 5.63558571,12.2000767 5.8263,12.5151233 C6.60201429,13.798286 7.98844286,14.2635651 9.6003,14.2635651 Z"
                          id="Fill-9"
                          fill="#000000"
                          mask="url(#mask-6)"
                        />
                      </g>
                      <path
                        d="M71.5127354,1.43557822 L72.9775077,6.07079646 C73.078264,6.39163042 72.827045,6.70436478 72.4925342,6.69176541 C70.290226,6.60671966 67.3736678,7.65651717 67.3736678,10.8639568 L67.3736678,18.5149243 C67.3736678,18.7831108 67.1573777,19 66.8909333,19 L62.4827345,19 C62.2158423,19 62,18.7831108 62,18.5149243 L62,1.48507575 C62,1.21733913 62.2158423,1 62.4827345,1 L66.8909333,1 C67.1573777,1 67.3736678,1.21733913 67.3736678,1.48507575 L67.3736678,2.01379931 C67.3736678,2.47232638 67.9602932,2.69101545 68.2352459,2.32518374 C68.8711299,1.47832608 69.7416641,1.14579271 71.0434351,1.09719514 C71.2570384,1.08909555 71.4478036,1.23083846 71.5127354,1.43557822"
                        id="Fill-12"
                        fill="#000000"
                      />
                      <path
                        d="M91.9711609,1.65336733 L86.0071913,18.6832158 C85.9403239,18.8735563 85.7686836,19 85.5761738,19 L80.4235562,19 C80.2318982,19 80.0594061,18.8735563 79.9929647,18.6832158 L74.028995,1.65336733 C73.9178334,1.33658317 74.1401566,1 74.4595866,1 L79.1236894,1 C79.3221618,1 79.4980612,1.13454327 79.5598177,1.33388331 L82.5637367,11.0070496 C82.7017304,11.4520774 83.2979996,11.4520774 83.4364192,11.0070496 L86.4403382,1.33388331 C86.5016688,1.13454327 86.6775682,1 86.8764666,1 L91.5401435,1 C91.8599993,1 92.0818966,1.33658317 91.9711609,1.65336733"
                        id="Fill-14"
                        fill="#000000"
                      />
                      <path
                        d="M95.4491667,1 L99.5508333,1 C99.79875,1 100,1.21688916 100,1.48507575 L100,18.5149243 C100,18.7831108 99.79875,19 99.5508333,19 L95.4491667,19 C95.2008333,19 95,18.7831108 95,18.5149243 L95,1.48507575 C95,1.21688916 95.2008333,1 95.4491667,1"
                        id="Fill-16"
                        fill="#000000"
                      />
                      <g
                        id="Group-20"
                        transform="translate(103.000000, 13.000000)"
                      >
                        <mask id="mask-8" fill="white">
                          <use xlink:href="#path-7" />
                        </mask>
                        <g id="Clip-19" />
                        <path
                          d="M1.7659125,5.32108 L0.9105375,4.40868 C0.1699125,3.61868 0.1699125,2.32628 0.9105375,1.53588 L1.7659125,0.62388 C2.5065375,-0.16612 3.7181625,-0.16612 4.4587875,0.62388 L5.3141625,1.53588 C6.0547875,2.32628 6.0547875,3.61868 5.3141625,4.40868 L4.4587875,5.32108 C3.7181625,6.11108 2.5065375,6.11108 1.7659125,5.32108"
                          id="Fill-18"
                          fill="#000000"
                          mask="url(#mask-8)"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </router-link>
          </div>
        </div>
        <div class="section-box">
          <ComponentMatthias />
          <FloatingSocials :hoverColor="projects[6].dot" />
          <FloatingText/>
          <div class="row col-sm-12">
            <div class="col-xs-12 col-md-6 title__box">
              <h2
                v-bind:style="{ color: projects[6].textColor }"
                style="transform: matrix(1, 0, 0, 1, 0, 0);"
              >
                <img
                  src="../assets/project-logos/matthias-logo.svg"
                  alt="matthias logo"
                  class="logo-intro matthias-logo"
                  data-aos="fade-up"
                />
                Food
                <br />rebranding.
                <span v-bind:style="{ color: projects[6].dot }">.</span>
              </h2>
              <div class="scroll-down">
                <span style="transform: matrix(1, 0, 0, 1, 0, 0);">
                  <span class="mouse">
                    <svg
                      version="1.1"
                      id="Capa_1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 512 512"
                      style="enable-background:new 0 0 512 512;"
                      xml:space="preserve"
                    >
                      <g>
                        <g>
                          <path
                            d="M256,140.15c-9.364,0-16.954,7.59-16.954,16.954v59.338c0,9.364,7.59,16.954,16.954,16.954
                              c9.364,0,16.954-7.59,16.954-16.954v-59.338C272.954,147.74,265.364,140.15,256,140.15z"
                          />
                        </g>
                      </g>
                    </svg>
                    <svg
                      version="1.1"
                      id="Capa_1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 512 512"
                      style="enable-background:new 0 0 512 512;"
                      xml:space="preserve"
                    >
                      <g>
                        <g>
                          <path
                            d="M256,0C156.595,0,75.726,82.14,75.726,183.099v145.807C75.726,429.865,156.595,512,256,512
                              c99.399,0,180.274-81.886,180.274-182.534V183.099C436.274,82.14,355.399,0,256,0z M402.366,329.466
                              c0,81.954-65.656,148.627-146.366,148.627c-80.705,0-146.366-66.927-146.366-149.192V183.099
                              c0-82.265,65.661-149.192,146.366-149.192c80.711,0,146.366,66.927,146.366,149.192V329.466z"
                          />
                        </g>
                      </g>
                    </svg>
                  </span>
                  <span>Scroll down</span>
                </span>
              </div>
            </div>
            <div class="col-xs-12 col-md-6"></div>
          </div>
        </div>
      </section>

      <!-- Description section -->
      <section class="section__project description">
        <div class="section-box title__box">
          <FloatingSocials :hoverColor="projects[6].dot" />
          <FloatingText/>

          <div class="text-container">
            <h2 data-aos="fade-up">
              MODERN TRADITION
              <br />Rebranding a traditional 30-yr-old firm? Yes, it's
              possible!
            </h2>

            <div class="specification" data-aos="fade-up">
              <ul>
                <li class="text-wrap text-wrap__small">
                  <span style="transform: matrix(1, 0, 0, 1, 0, 0);"
                    >Agency</span
                  >
                </li>
                <li class="text-wrap text-wrap__small">
                  <span style="transform: matrix(1, 0, 0, 1, 0, 0);">{{
                    projects[6].agency
                  }}</span>
                </li>
              </ul>
              <ul>
                <li class="text-wrap text-wrap__small">
                  <span style="transform: matrix(1, 0, 0, 1, 0, 0);"
                    >Client</span
                  >
                </li>
                <li class="text-wrap text-wrap__small">
                  <span style="transform: matrix(1, 0, 0, 1, 0, 0);">{{
                    projects[6].client
                  }}</span>
                </li>
              </ul>
              <ul>
                <li class="text-wrap text-wrap__small">
                  <span style="transform: matrix(1, 0, 0, 1, 0, 0);"
                    >Solutions</span
                  >
                </li>
                <li class="text-wrap text-wrap__small">
                  <span style="transform: matrix(1, 0, 0, 1, 0, 0);">{{
                    projects[6].role
                  }}</span>
                </li>
              </ul>
            </div>

            <p class="text-standard" data-aos="fade-up">
              It's time for a change. The new brand has to attract attention
              with minimal form and also reach the younger generation. The piggy
              logo has gained a slightly odd, "devilish" character. We’ve
              focused on simplicity in package design - it is familiar and
              natural, but modernised. This project emphasizes high quality
              products and is associated with exclusive goods. Photo sessions in
              a brand new arrangement were also one of our tasks. The most
              important aspect of the pictures are the meat products. Stylized
              shots where every detail matters encourage customers to make an
              impulse purchase. The arrangement also suggests a traditional,
              homey character, which is why we used wood and stone as well as
              herbs and spices.
            </p>
            <div class="row lists" data-aos="fade-up">
              <ul class="col-xs-12 col-sm-6 col-md-3 pb-4">
                <span>Website</span>
                <li v-for="(item, index) in projects[6].Webpage" :key="index">
                  {{ item }}
                </li>
              </ul>
              <ul class="col-xs-12 col-sm-6 col-md-3 pb-4">
                <span>Content marketing</span>
                <li
                  v-for="(item, index) in projects[6].ContentMarketing"
                  :key="index"
                >
                  {{ item }}
                </li>
              </ul>
              <ul class="col-xs-12 col-sm-6 col-md-3 pb-4">
                <span>Visual ID</span>
                <li
                  v-for="(item, index) in projects[6].VisualIdentification"
                  :key="index"
                >
                  {{ item }}
                </li>
              </ul>
              <ul class="col-xs-12 col-sm-6 col-md-3 pb-4">
                <span>Brand strategy</span>
                <li
                  v-for="(item, index) in projects[6].BrandStrategy"
                  :key="index"
                >
                  {{ item }}
                </li>
              </ul>
            </div>
            <CaseContact data-aos="fade-up" />
          </div>
        </div>
      </section>

      <!-- Other information -->
      <section class="section__project other">
       <img
          class="img-full lazyload pb-0 pt-0"
          src="https://ik.imagekit.io/intervi/matthias/tr:w-1920,h-1080/matthias-steak_-yIjir0oI.jpg"
          data-src="https://ik.imagekit.io/intervi/matthias/tr:w-1920,h-1080/matthias-steak_-yIjir0oI.jpg"
          alt="Stek wołowy propozycja podania"
          data-aos="fade-up"
        />
        <div
          class="d-flex justify-content-center align-content-center other__logo-box"
          data-aos="fade-up"
        >
          <svg
            width="150"
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 396.46 376.15"
            style="enable-background:new 0 0 396.46 376.15;"
            xml:space="preserve"
          >
            <g class="svg-subtitle">
              <path
                class="st0"
                d="M90.78,314.28h9.02v1.9l-5.44,6.27h5.62v2.39l-9.39-0.02v-1.9l5.44-6.27l-5.25-0.02V314.28z"
              />
              <path
                class="st0"
                d="M117.92,310.25v14.58h-3.01v-1.55c-0.38,0.55-0.85,0.96-1.42,1.25c-0.56,0.28-1.21,0.42-1.93,0.42
                c-1,0-1.87-0.23-2.62-0.68c-0.76-0.46-1.34-1.09-1.75-1.92c-0.41-0.83-0.62-1.77-0.62-2.85c0-1.06,0.2-2,0.61-2.81
                c0.41-0.82,0.98-1.44,1.73-1.89c0.75-0.45,1.6-0.67,2.57-0.67c1.49,0,2.63,0.56,3.42,1.67v-5.56H117.92z M114.18,321.7
                c0.49-0.54,0.74-1.25,0.74-2.11c0-0.87-0.25-1.57-0.74-2.12c-0.49-0.54-1.12-0.82-1.9-0.82c-0.79,0-1.42,0.27-1.92,0.82
                c-0.49,0.55-0.74,1.25-0.76,2.12c0.01,0.86,0.27,1.57,0.76,2.11c0.49,0.54,1.13,0.82,1.92,0.82
                C113.05,322.51,113.69,322.24,114.18,321.7z"
              />
              <path
                class="st0"
                d="M130.91,314.67c0.59-0.34,1.28-0.52,2.06-0.53v2.85c-0.11-0.01-0.26-0.02-0.47-0.02
                c-0.93,0-1.67,0.25-2.21,0.76c-0.54,0.5-0.82,1.18-0.82,2.01v5.09h-3.03v-10.57h3.03v1.9
                C129.84,315.51,130.32,315.01,130.91,314.67z"
              />
              <path
                class="st0"
                d="M147.86,314.83c0.86,0.45,1.52,1.07,1.99,1.89c0.47,0.81,0.71,1.76,0.71,2.83c0,1.07-0.24,2.01-0.71,2.82
                c-0.47,0.82-1.14,1.45-1.99,1.91c-0.86,0.45-1.84,0.68-2.96,0.68c-1.13,0-2.12-0.23-2.98-0.68c-0.86-0.46-1.52-1.09-2-1.91
                c-0.47-0.82-0.71-1.76-0.71-2.82c0-1.07,0.24-2.01,0.71-2.83c0.47-0.82,1.14-1.44,2-1.89c0.86-0.44,1.85-0.67,2.98-0.67
                C146.01,314.16,147,314.39,147.86,314.83z M142.98,317.48c-0.49,0.54-0.74,1.24-0.74,2.11c0,0.86,0.24,1.56,0.74,2.1
                c0.49,0.54,1.13,0.81,1.92,0.81c0.77,0,1.41-0.27,1.89-0.81c0.49-0.54,0.74-1.24,0.74-2.1c0-0.87-0.25-1.57-0.74-2.11
                c-0.49-0.54-1.12-0.81-1.89-0.81C144.11,316.67,143.48,316.94,142.98,317.48z"
              />
              <path
                class="st0"
                d="M156.2,314.28l3.09-0.02l2.36,7.57l2.28-7.57h2.97l2.32,7.57l2.32-7.57h2.99l-3.85,10.57h-3.03l-2.28-6.98
                l-2.26,6.98h-3.03L156.2,314.28z"
              />
              <path
                class="st0"
                d="M189.42,315.63c0.89,0.98,1.33,2.35,1.33,4.11c0,0.32,0,0.56-0.02,0.73h-7.58c0.17,0.67,0.5,1.19,0.98,1.56
                c0.48,0.37,1.07,0.56,1.75,0.56c0.5,0,0.98-0.09,1.43-0.28s0.87-0.47,1.24-0.83l1.59,1.61c-0.54,0.6-1.19,1.07-1.95,1.38
                c-0.77,0.32-1.62,0.48-2.56,0.48c-1.11,0-2.08-0.23-2.92-0.67c-0.83-0.45-1.48-1.07-1.93-1.89c-0.45-0.81-0.68-1.75-0.68-2.81
                c0-1.07,0.23-2.02,0.69-2.84c0.46-0.82,1.1-1.45,1.93-1.91c0.83-0.45,1.77-0.68,2.83-0.68
                C187.24,314.16,188.53,314.65,189.42,315.63z M187.9,318.68c-0.03-0.7-0.25-1.25-0.67-1.67c-0.42-0.42-0.98-0.63-1.67-0.63
                c-0.65,0-1.2,0.21-1.64,0.62c-0.44,0.41-0.72,0.97-0.83,1.68H187.9z"
              />
              <path
                class="st0"
                d="M206.82,314.28l3.09-0.02l2.36,7.57l2.28-7.57h2.97l2.32,7.57l2.32-7.57h2.99l-3.85,10.57h-3.03l-2.28-6.98
                l-2.26,6.98h-3.03L206.82,314.28z"
              />
              <path
                class="st0"
                d="M240.03,315.63c0.89,0.98,1.33,2.35,1.33,4.11c0,0.32,0,0.56-0.02,0.73h-7.58c0.17,0.67,0.5,1.19,0.98,1.56
                c0.48,0.37,1.07,0.56,1.75,0.56c0.5,0,0.98-0.09,1.43-0.28s0.87-0.47,1.24-0.83l1.59,1.61c-0.25,0.29-0.54,0.54-0.86,0.76
                c-0.47,0.45-0.85,0.94-1.15,1.48c-0.3,0.54-0.44,1-0.44,1.39c0,0.41,0.16,0.61,0.47,0.61c0.21,0,0.41-0.05,0.59-0.15l0.55,1.73
                c-0.63,0.27-1.22,0.41-1.79,0.41c-0.65,0-1.18-0.18-1.58-0.54c-0.4-0.36-0.6-0.88-0.6-1.56c0-0.79,0.32-1.54,0.96-2.28l-0.67,0.02
                c-1.11,0-2.08-0.23-2.92-0.67c-0.83-0.45-1.48-1.07-1.93-1.89c-0.45-0.81-0.68-1.75-0.68-2.81c0-1.07,0.23-2.02,0.69-2.84
                c0.46-0.82,1.1-1.45,1.93-1.91c0.83-0.45,1.77-0.68,2.83-0.68C237.86,314.16,239.15,314.65,240.03,315.63z M238.51,318.68
                c-0.03-0.7-0.25-1.25-0.67-1.67c-0.42-0.42-0.98-0.63-1.67-0.63c-0.65,0-1.2,0.21-1.64,0.62c-0.44,0.41-0.72,0.97-0.83,1.68H238.51
                z"
              />
              <path
                class="st0"
                d="M259.28,310.25v14.58h-3.01v-1.55c-0.38,0.55-0.85,0.96-1.42,1.25c-0.56,0.28-1.21,0.42-1.93,0.42
                c-1,0-1.87-0.23-2.62-0.68c-0.76-0.46-1.34-1.09-1.75-1.92c-0.41-0.83-0.62-1.77-0.62-2.85c0-1.06,0.2-2,0.61-2.81
                c0.41-0.82,0.98-1.44,1.73-1.89c0.75-0.45,1.6-0.67,2.57-0.67c1.49,0,2.63,0.56,3.42,1.67v-5.56H259.28z M255.54,321.7
                c0.49-0.54,0.74-1.25,0.74-2.11c0-0.87-0.25-1.57-0.74-2.12c-0.49-0.54-1.12-0.82-1.9-0.82c-0.79,0-1.42,0.27-1.92,0.82
                c-0.49,0.55-0.74,1.25-0.76,2.12c0.01,0.86,0.27,1.57,0.76,2.11c0.49,0.54,1.13,0.82,1.92,0.82
                C254.41,322.51,255.05,322.24,255.54,321.7z"
              />
              <path class="st0" d="M267.91,310.25h3.03v14.58h-3.03V310.25z" />
              <path
                class="st0"
                d="M282.14,310.03c0.31,0.31,0.46,0.72,0.46,1.22c0,0.5-0.15,0.9-0.46,1.22c-0.31,0.31-0.7,0.47-1.19,0.47
                c-0.47,0-0.86-0.16-1.17-0.48c-0.31-0.32-0.46-0.72-0.46-1.21c0-0.5,0.15-0.91,0.46-1.22c0.31-0.32,0.7-0.47,1.17-0.47
                C281.44,309.56,281.84,309.72,282.14,310.03z M279.46,314.26h3.03v10.57h-3.03V314.26z"
              />
              <path
                class="st0"
                d="M300.4,315.24c0.7,0.73,1.05,1.72,1.05,2.95v6.64h-3.02v-5.76c0-0.67-0.19-1.19-0.56-1.58
                c-0.37-0.38-0.88-0.58-1.52-0.58c-0.75,0.01-1.34,0.27-1.77,0.77c-0.43,0.51-0.65,1.15-0.65,1.94v5.21h-3.03v-10.57h3.03v1.85
                c0.73-1.29,1.95-1.94,3.65-1.97C298.76,314.14,299.7,314.51,300.4,315.24z"
              />
              <path
                class="st0"
                d="M310.63,328.78c-0.56,0-1.07-0.09-1.53-0.25c-0.46-0.16-0.9-0.42-1.34-0.77l1.28-2.18
                c0.46,0.38,0.92,0.57,1.37,0.57c0.64,0,1.11-0.32,1.4-0.95l0.3-0.59l-4.38-10.35h3.13l2.77,7.27l2.49-7.27h3.03l-4.64,11.75
                C313.76,327.86,312.47,328.78,310.63,328.78z"
              />
            </g>
            <g>
              <path
                class="st0"
                d="M209,134.38c-19.73,0-35.78,12.29-35.78,27.4c0,15.11,16.05,27.39,35.78,27.39
                c19.73,0,35.78-12.29,35.78-27.39C244.78,146.67,228.72,134.38,209,134.38z M209,177.62c-13.13,0-24.22-7.25-24.22-15.84
                c0-8.59,11.09-15.84,24.22-15.84c13.13,0,24.22,7.25,24.22,15.84C233.22,170.37,222.13,177.62,209,177.62z"
              />
              <path
                class="st0"
                d="M184.82,133.5c4.2,0,7.62-3.42,7.62-7.61c0-4.2-3.42-7.62-7.62-7.62c-4.2,0-7.62,3.42-7.62,7.62
                C177.21,130.08,180.62,133.5,184.82,133.5z"
              />
              <path
                class="st0"
                d="M233.17,133.5c4.2,0,7.62-3.42,7.62-7.61c0-4.2-3.42-7.62-7.62-7.62c-4.2,0-7.62,3.42-7.62,7.62
                C225.56,130.08,228.97,133.5,233.17,133.5z"
              />
              <path
                class="st0"
                d="M201.62,150.48c-2.6,0-4.71,2.12-4.71,4.73v13.14c0,2.61,2.11,4.73,4.71,4.73s4.71-2.12,4.71-4.73v-13.14
                C206.33,152.6,204.21,150.48,201.62,150.48z"
              />
              <path
                class="st0"
                d="M216.47,150.48c-2.6,0-4.71,2.12-4.71,4.73v13.14c0,2.61,2.11,4.73,4.71,4.73c2.6,0,4.71-2.12,4.71-4.73
                v-13.14C221.18,152.6,219.07,150.48,216.47,150.48z"
              />
              <path
                class="st0"
                d="M321.73,189.99c-1.44-2.46-4.6-3.28-7.05-1.84c-1.56,0.91-3.21,1.52-4.89,1.84c4.1-4.87,4.92-11.99,1.52-17.79
                c-4.31-7.36-13.8-9.83-21.16-5.52c-7.36,4.31-9.83,13.8-5.52,21.16c0.13,0.23,0.27,0.45,0.42,0.68c0.64,1.02,1.34,1.98,2.1,2.88
                c-5.48,1.1-11.4-0.9-15.16-5.27c13.76-15.21,22.15-35.37,22.15-57.45c0-14.49-3.63-28.14-10-40.12l-0.25-4.95
                c-1.47-28.55-10.42-39.5-11.44-40.65l-2.25-2.55l-3.31,0.76c-0.52,0.12-11.45,2.75-18.45,11.73c-11.96-6.34-25.58-9.95-40.03-9.95
                c-15.4,0-29.85,4.1-42.35,11.24c-6.91-10.03-18.86-12.89-19.4-13.01l-3.31-0.76l-2.25,2.55c-1.02,1.15-9.97,12.1-11.44,40.65
                l-0.66,12.82c-4.06,9.96-6.32,20.85-6.32,32.25c0,47.27,38.46,85.73,85.73,85.73c21.48,0,41.13-7.96,56.19-21.07
                c3.34,3.71,7.67,6.42,12.61,7.76c6.75,1.84,13.74,0.94,19.68-2.54l0.01-0.01c7.22,3.02,15.73,2.73,22.99-1.52
                C322.35,195.61,323.17,192.45,321.73,189.99z M258.55,58.59c2.27-2.39,5.03-3.97,7.2-4.95c1.52,2.99,3.62,8.2,5.1,16.2
                c-0.45-0.4-0.91-0.82-1.36-1.22c-2.28-2.32-4.7-4.51-7.23-6.56C260.97,60.85,259.71,59.68,258.55,58.59z M147.78,53.63
                c2.17,0.98,4.93,2.56,7.21,4.95c-3.64,3.45-8.19,7.57-12.31,11.25C144.17,61.81,146.27,56.6,147.78,53.63z M208.41,203.01
                c-40.98,0-74.33-33.34-74.33-74.33c0-27.94,15.5-52.31,38.34-65.01l7.09,13.21c0,0,9.58-12.81,8.5-16.66l13.95,18.48l4.8-17.71
                l33.97,30.4l-2.66-30.85c6.02,2.63,11.62,6.04,16.68,10.09c2.25,2.07,4.62,4.22,6.91,6.27c13.02,13.4,21.07,31.66,21.07,51.77
                C282.73,169.67,249.39,203.01,208.41,203.01z M300.58,184.47c-2.45,1.44-5.62,0.61-7.05-1.84s-0.61-5.62,1.84-7.05
                c2.45-1.44,5.62-0.61,7.05,1.84C303.85,179.87,303.03,183.03,300.58,184.47z"
              />
            </g>
            <g>
              <path
                class="st0"
                d="M19.59,252.73h15.12v5.26c4.12-3.95,8.74-5.93,13.86-5.93c6.35,0,11.19,2.67,14.53,8.02
                c3.4-5.4,8.24-8.1,14.53-8.1c2.01,0,3.9,0.29,5.68,0.88c1.78,0.58,3.31,1.5,4.59,2.75c1.28,1.25,2.3,2.88,3.05,4.88
                c0.75,2.01,1.13,4.43,1.13,7.27v27.81H76.97v-21.13c0-2.17-0.16-3.95-0.46-5.35c-0.31-1.39-0.75-2.48-1.34-3.25
                c-0.59-0.78-1.27-1.31-2.04-1.59c-0.78-0.28-1.62-0.42-2.5-0.42c-4.85,0-7.27,3.54-7.27,10.61v21.13H48.24v-21.13
                c0-2.17-0.14-3.97-0.42-5.39c-0.28-1.42-0.68-2.55-1.21-3.38c-0.53-0.83-1.21-1.41-2.05-1.71c-0.83-0.31-1.81-0.46-2.92-0.46
                c-0.95,0-1.84,0.14-2.67,0.42c-0.83,0.28-1.57,0.82-2.21,1.63c-0.64,0.81-1.14,1.92-1.51,3.34c-0.36,1.42-0.54,3.27-0.54,5.56
                v21.13H19.59V252.73z"
              />
              <path
                class="st0"
                d="M133,252.73h15.2v42.85H133v-4.76c-3.23,4.07-7.6,6.1-13.11,6.1c-3.12,0-5.99-0.57-8.6-1.71
                c-2.62-1.14-4.9-2.74-6.85-4.8c-1.95-2.06-3.46-4.48-4.55-7.26c-1.09-2.78-1.63-5.82-1.63-9.11c0-3.06,0.53-5.97,1.59-8.73
                c1.06-2.75,2.53-5.16,4.43-7.22c1.89-2.06,4.14-3.69,6.76-4.89c2.61-1.19,5.51-1.79,8.68-1.79c5.34,0,9.77,1.87,13.28,5.59V252.73z
                 M113.96,274.03c0,1.4,0.25,2.69,0.75,3.89c0.5,1.2,1.18,2.24,2.04,3.13c0.86,0.89,1.89,1.59,3.09,2.09s2.49,0.75,3.89,0.75
                c1.33,0,2.6-0.25,3.8-0.75c1.19-0.5,2.23-1.19,3.09-2.09s1.56-1.92,2.09-3.09c0.53-1.17,0.79-2.42,0.79-3.76
                c0-1.33-0.26-2.6-0.79-3.8c-0.53-1.19-1.22-2.24-2.09-3.13c-0.86-0.89-1.89-1.58-3.09-2.09c-1.2-0.5-2.47-0.75-3.8-0.75
                c-1.4,0-2.69,0.25-3.89,0.75c-1.2,0.5-2.23,1.2-3.09,2.09c-0.86,0.89-1.54,1.91-2.04,3.05
                C114.21,271.45,113.96,272.69,113.96,274.03z"
              />
              <path
                class="st0"
                d="M172.84,265.34v30.23h-15.12v-30.23h-5.01v-12.61h5.01v-12.86h15.12v12.86h8.6v12.61H172.84z"
              />
              <path
                class="st0"
                d="M203.73,265.34v30.23h-15.12v-30.23h-5.01v-12.61h5.01v-12.86h15.12v12.86h8.6v12.61H203.73z"
              />
              <path
                class="st0"
                d="M217.43,226.26h15.12v31.9c2.06-2.5,4.15-4.19,6.27-5.05c2.12-0.86,4.59-1.3,7.43-1.3
                c5.4,0,9.48,1.49,12.23,4.47c2.76,2.98,4.14,7,4.14,12.07v27.22h-15.12v-21.63c0-2.17-0.17-3.92-0.5-5.26
                c-0.34-1.33-0.89-2.37-1.67-3.09c-1.34-1.17-2.96-1.75-4.85-1.75c-2.56,0-4.52,0.76-5.89,2.29c-1.37,1.54-2.05,3.72-2.05,6.56
                v22.88h-15.12V226.26z"
              />
              <path
                class="st0"
                d="M269.37,236.28c0-1.17,0.23-2.27,0.67-3.3c0.44-1.03,1.06-1.93,1.84-2.71c0.78-0.78,1.68-1.39,2.71-1.84
                c1.03-0.45,2.13-0.67,3.3-0.67c1.17,0,2.27,0.23,3.3,0.67c1.03,0.45,1.93,1.06,2.71,1.84c0.78,0.78,1.39,1.68,1.84,2.71
                c0.45,1.03,0.67,2.13,0.67,3.3s-0.23,2.27-0.67,3.3c-0.45,1.03-1.06,1.93-1.84,2.71c-0.78,0.78-1.68,1.4-2.71,1.84
                c-1.03,0.45-2.13,0.67-3.3,0.67c-1.17,0-2.27-0.23-3.3-0.67c-1.03-0.44-1.93-1.06-2.71-1.84c-0.78-0.78-1.4-1.68-1.84-2.71
                C269.6,238.55,269.37,237.45,269.37,236.28z M285.49,252.73v42.85h-15.12v-42.85H285.49z"
              />
              <path
                class="st0"
                d="M326.41,252.73h15.2v42.85h-15.2v-4.76c-3.23,4.07-7.6,6.1-13.11,6.1c-3.12,0-5.99-0.57-8.6-1.71
                c-2.62-1.14-4.9-2.74-6.85-4.8c-1.95-2.06-3.46-4.48-4.55-7.26c-1.09-2.78-1.63-5.82-1.63-9.11c0-3.06,0.53-5.97,1.59-8.73
                c1.06-2.75,2.53-5.16,4.43-7.22c1.89-2.06,4.14-3.69,6.76-4.89c2.61-1.19,5.51-1.79,8.68-1.79c5.34,0,9.77,1.87,13.28,5.59V252.73z
                 M307.37,274.03c0,1.4,0.25,2.69,0.75,3.89c0.5,1.2,1.18,2.24,2.04,3.13s1.89,1.59,3.09,2.09c1.2,0.5,2.49,0.75,3.89,0.75
                c1.33,0,2.6-0.25,3.8-0.75c1.19-0.5,2.23-1.19,3.09-2.09c0.86-0.89,1.56-1.92,2.09-3.09c0.53-1.17,0.79-2.42,0.79-3.76
                c0-1.33-0.26-2.6-0.79-3.8c-0.53-1.19-1.22-2.24-2.09-3.13c-0.86-0.89-1.89-1.58-3.09-2.09c-1.2-0.5-2.47-0.75-3.8-0.75
                c-1.4,0-2.69,0.25-3.89,0.75c-1.2,0.5-2.23,1.2-3.09,2.09c-0.86,0.89-1.54,1.91-2.04,3.05
                C307.62,271.45,307.37,272.69,307.37,274.03z"
              />
              <path
                class="st0"
                d="M377.77,263.76c-2.78-1.44-5.51-2.17-8.18-2.17c-1.39,0-2.52,0.28-3.38,0.83c-0.86,0.56-1.3,1.31-1.3,2.25
                c0,0.5,0.07,0.91,0.21,1.21c0.14,0.31,0.44,0.6,0.92,0.88c0.47,0.28,1.17,0.53,2.09,0.75c0.92,0.22,2.13,0.5,3.64,0.83
                c4.17,0.83,7.29,2.32,9.35,4.47c2.06,2.14,3.09,4.88,3.09,8.23c0,2.5-0.5,4.76-1.5,6.76c-1,2.01-2.39,3.69-4.17,5.05
                c-1.78,1.37-3.92,2.42-6.43,3.17c-2.5,0.75-5.26,1.13-8.27,1.13c-5.79,0-11.5-1.65-17.12-4.93l5.51-10.69
                c4.23,2.9,8.24,4.34,12.03,4.34c1.39,0,2.53-0.3,3.43-0.92c0.89-0.61,1.33-1.39,1.33-2.34c0-0.56-0.07-1.02-0.21-1.38
                c-0.14-0.36-0.43-0.7-0.88-1c-0.45-0.3-1.1-0.58-1.96-0.83c-0.86-0.25-1.99-0.51-3.38-0.79c-4.68-0.95-7.95-2.35-9.82-4.22
                c-1.87-1.87-2.8-4.44-2.8-7.72c0-2.39,0.45-4.55,1.34-6.48c0.89-1.92,2.17-3.55,3.84-4.88c1.67-1.33,3.69-2.37,6.06-3.09
                c2.37-0.72,4.99-1.08,7.89-1.08c4.73,0,9.32,0.92,13.78,2.75L377.77,263.76z"
              />
            </g>
          </svg>
        </div>
        <img
          class="img-full lazyload"
          src="https://ik.imagekit.io/intervi/4-stek_wieprzowy_l9fJ-apnvz.jpg"
          data-src="https://ik.imagekit.io/intervi/4-stek_wieprzowy_l9fJ-apnvz.jpg"
          alt="Stek wieprzowy w opakowaniu na białym tle"
          data-aos="fade-up"
        />
        <img
          class="img-full lazyload"
          src="https://ik.imagekit.io/intervi/5-szynka_suszona_NVJP1qMPH.jpg"
          data-src="https://ik.imagekit.io/intervi/5-szynka_suszona_NVJP1qMPH.jpg"
          alt="Dwa opakowania suszonej szynki Matthias"
          data-aos="fade-up"
        />
        <div class="row other__boxes">
          <div class="col-6 col-md-4">
            <img
              src="https://ik.imagekit.io/intervi/6-zdjecie1x6_w82iLIIH6K.jpg"
              alt="Schab propozycja podania"
              data-aos="fade-up"
            />
          </div>
          <div class="col-6 col-md-4">
            <img
              src="https://ik.imagekit.io/intervi/6-zdjecie2x6_2UmcaN1wE.jpg"
              alt="Kiełbasa propozycja podania"
              data-aos="fade-up"
            />
          </div>
          <div class="col-6 col-md-4">
            <img
              src="https://ik.imagekit.io/intervi/6-zdjecie3x6_Un5DSBBOuq.jpg"
              alt="Schab propozycja podania"
              data-aos="fade-up"
            />
          </div>
          <div class="col-6 col-md-4">
            <img
              src="https://ik.imagekit.io/intervi/6-zdjecie4x6_Rj3depL-V.jpg"
              alt="Boczek propozycja podania"
              data-aos="fade-up"
            />
          </div>
          <div class="col-6 col-md-4">
            <img
              src="https://ik.imagekit.io/intervi/6-zdjecie5x6_r8PuciFvTb.jpg"
              alt="Boczek propozycja podania"
              data-aos="fade-up"
            />
          </div>
          <div class="col-6 col-md-4">
            <img
              src="https://ik.imagekit.io/intervi/6-zdjecie6x6_n2gjX0UtI.jpg"
              alt="Kiełbasa propozycja podania"
              data-aos="fade-up"
            />
          </div>
        </div>
        <div class="position-relative" data-aos="fade-up">
          <img
            class="pepper"
            src="https://ik.imagekit.io/intervi/7-przyprawy_QVo8yL8v-P.png"
            data-src="https://ik.imagekit.io/intervi/7-przyprawy_QVo8yL8v-P.png"
            alt
          />
          <img
            class="garlic"
            src="https://ik.imagekit.io/intervi/7-garlic_BsT8SHM3r.png"
            data-src="https://ik.imagekit.io/intervi/7-garlic_BsT8SHM3r.png"
            alt
          />
          <img
            class="img-full lazyload pb-0"
            src="https://ik.imagekit.io/intervi/pierogi_2XQSWa0zz.jpg"
            data-src="https://ik.imagekit.io/intervi/pierogi_2XQSWa0zz.jpg"
            alt="Opakowania pierogów Matthias"
          />
        </div>
        <div class="row other__logos-box">
          <div class="col-6" data-aos="fade-up">
            <svg
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 396.46 376.15"
              style="enable-background:new 0 0 396.46 376.15;"
              xml:space="preserve"
            >
              <g>
                <path
                  class="st0"
                  d="M85.46,275.61v27.77H71.89v-26.59c0-4.52-2.17-7.42-6.51-7.42c-4.52,0-7.05,3.17-7.05,8.5v25.51H44.76v-26.59
              		c0-4.52-2.17-7.42-6.51-7.42c-4.52,0-7.05,3.17-7.05,8.5v25.51H17.62v-45.23h13.57v4.16c2.08-3.07,6.06-5.43,12.12-5.43
              		c5.34,0,9.32,2.17,11.85,5.97c2.53-3.62,6.69-5.97,13.12-5.97C78.68,256.89,85.46,264.31,85.46,275.61z"
                />
                <path
                  class="st0"
                  d="M141.19,258.16v45.23h-13.57v-4.25c-2.98,3.44-7.42,5.52-13.48,5.52c-11.85,0-21.62-10.4-21.62-23.88
              		c0-13.48,9.77-23.88,21.62-23.88c6.06,0,10.49,2.08,13.48,5.52v-4.25H141.19z M127.62,280.77c0-6.79-4.52-11.04-10.76-11.04
              		s-10.76,4.25-10.76,11.04c0,6.78,4.52,11.03,10.76,11.03S127.62,287.55,127.62,280.77z"
                />
                <path
                  class="st0"
                  d="M168.34,271.18v16.01c0,3.89,3.35,4.25,9.32,3.89v12.3c-17.73,1.81-22.88-3.53-22.88-16.19v-16.01h-7.24
              		v-13.03h7.24v-8.59l13.57-4.07v12.66h13.84v13.03H168.34z"
                />
                <path
                  class="st0"
                  d="M201.18,271.18v16.01c0,3.89,3.35,4.25,9.32,3.89v12.3c-17.73,1.81-22.88-3.53-22.88-16.19v-16.01h-7.24
              		v-13.03h7.24v-8.59l13.57-4.07v12.66h9.32v13.03H201.18z"
                />
                <path
                  class="st0"
                  d="M261.6,275.61v27.77h-13.57V277.6c0-5.61-3.53-8.23-7.87-8.23c-4.97,0-8.41,2.89-8.41,9.32v24.69h-13.57
              		v-63.32h13.57v22.34c2.44-3.35,6.97-5.52,12.94-5.52C253.82,256.89,261.6,263.4,261.6,275.61z"
                />
                <path
                  class="st0"
                  d="M269.57,246.04c0-4.43,3.71-8.14,8.14-8.14s8.14,3.71,8.14,8.14c0,4.43-3.71,8.14-8.14,8.14
              		S269.57,250.47,269.57,246.04z M270.93,258.16h13.57v45.23h-13.57V258.16z"
                />
                <path
                  class="st0"
                  d="M340.85,258.16v45.23h-13.57v-4.25c-2.98,3.44-7.42,5.52-13.48,5.52c-11.85,0-21.62-10.4-21.62-23.88
              		c0-13.48,9.77-23.88,21.62-23.88c6.06,0,10.49,2.08,13.48,5.52v-4.25H340.85z M327.28,280.77c0-6.79-4.52-11.04-10.76-11.04
              		c-6.24,0-10.76,4.25-10.76,11.04c0,6.78,4.52,11.03,10.76,11.03C322.76,291.8,327.28,287.55,327.28,280.77z"
                />
                <path
                  class="st0"
                  d="M385.45,289.81c0,10.4-9.04,14.83-18.81,14.83c-9.04,0-15.92-3.44-19.45-10.76l11.76-6.69
              		c1.18,3.44,3.71,5.34,7.69,5.34c3.26,0,4.88-1,4.88-2.81c0-4.97-22.25-2.35-22.25-18c0-9.86,8.32-14.83,17.73-14.83
              		c7.33,0,13.84,3.26,17.64,9.68l-11.58,6.24c-1.27-2.35-3.08-3.98-6.06-3.98c-2.35,0-3.8,0.9-3.8,2.53
              		C363.2,276.52,385.45,273.08,385.45,289.81z"
                />
              </g>
              <g>
                <path
                  class="st0"
                  d="M204.4,125.82c-20.46,0-37.11,12.75-37.11,28.42c0,15.67,16.65,28.42,37.11,28.42
              		c20.46,0,37.11-12.75,37.11-28.42C241.51,138.57,224.86,125.82,204.4,125.82z M204.4,170.66c-13.62,0-25.12-7.52-25.12-16.43
              		c0-8.91,11.5-16.43,25.12-16.43c13.62,0,25.13,7.52,25.13,16.43C229.53,163.14,218.02,170.66,204.4,170.66z"
                />
                <path
                  class="st0"
                  d="M179.32,124.9c4.36,0,7.9-3.54,7.9-7.9c0-4.36-3.54-7.9-7.9-7.9c-4.36,0-7.9,3.54-7.9,7.9
              		C171.42,121.36,174.97,124.9,179.32,124.9z"
                />
                <path
                  class="st0"
                  d="M229.48,124.9c4.36,0,7.9-3.54,7.9-7.9c0-4.36-3.54-7.9-7.9-7.9c-4.36,0-7.9,3.54-7.9,7.9
              		C221.58,121.36,225.12,124.9,229.48,124.9z"
                />
                <path
                  class="st0"
                  d="M196.75,142.51c-2.69,0-4.88,2.2-4.88,4.9v13.63c0,2.7,2.19,4.9,4.88,4.9s4.88-2.2,4.88-4.9v-13.63
              		C201.63,144.71,199.44,142.51,196.75,142.51z"
                />
                <path
                  class="st0"
                  d="M218.41,183.82c-0.45,0-0.89,0.07-1.31,0.22c-3.14,1.07-9.1,1.81-14.49,1.81c-4.4,0-8.25-0.46-11.15-1.34
              		c-0.64-0.19-1.29-0.29-1.94-0.29c-2.15,0-3.93,1.09-4.76,2.91c-0.65,1.43-0.64,3.18,0.03,4.58c0.56,1.18,1.52,2,2.71,2.31
              		c5.77,1.51,11.05,2.24,16.13,2.24c5.8,0,10.22-0.97,13.78-1.75c0.56-0.12,1.11-0.24,1.64-0.35c2.17-0.45,3.81-2.1,4.17-4.2
              		c0.1-0.58,0.1-1.17,0-1.75C222.79,185.74,220.68,183.82,218.41,183.82z"
                />
                <path
                  class="st0"
                  d="M212.15,142.51c-2.69,0-4.88,2.2-4.88,4.9v13.63c0,2.7,2.19,4.9,4.88,4.9s4.88-2.2,4.88-4.9v-13.63
              		C217.04,144.71,214.84,142.51,212.15,142.51z"
                />
                <path
                  class="st0"
                  d="M321.34,194.35c-1.49-2.55-4.77-3.4-7.32-1.91c-1.62,0.95-3.33,1.58-5.08,1.91c4.25-5.05,5.1-12.44,1.58-18.45
              		c-4.47-7.63-14.32-10.2-21.95-5.73c-7.63,4.47-10.2,14.32-5.73,21.95c0.14,0.24,0.28,0.47,0.44,0.7c0.67,1.06,1.39,2.06,2.18,2.99
              		c-5.68,1.14-11.83-0.94-15.73-5.47c14.27-15.78,22.98-36.69,22.98-59.59c0-16.11-4.33-31.21-11.85-44.26l-0.2-3.91
              		c-2.06-40.02-30.51-54.64-31.72-55.24l-8.56-4.26v26.67c-11.17-5.07-23.56-7.92-36.61-7.92c-13.16,0-25.65,2.9-36.9,8.05v-26.8
              		l-8.55,4.26c-1.21,0.6-29.66,15.23-31.72,55.24l-0.23,4.47c-7.32,12.92-11.53,27.82-11.53,43.7c0,49.04,39.89,88.93,88.93,88.93
              		c22.29,0,42.67-8.26,58.29-21.85c3.46,3.85,7.96,6.65,13.08,8.05c7,1.91,14.25,0.98,20.42-2.63l0.01-0.01
              		c7.49,3.13,16.32,2.83,23.84-1.58C321.98,200.17,322.83,196.9,321.34,194.35z M252.23,44.38c4.6,4.43,10,11.35,13.4,21.38
              		c-4.4-3.98-9.22-8.02-13.4-10.76V44.38z M155.05,44.38V55c-4.18,2.74-9,6.78-13.4,10.76C145.05,55.72,150.45,48.81,155.05,44.38z
              		 M203.79,207.86c-42.51,0-77.1-34.59-77.1-77.1c0-33.06,20.91-61.31,50.2-72.25l24.48,20.41l-3.54-18.37l43.76,31.54l-7.02-32
              		c27.24,11.91,46.32,39.1,46.32,70.67C280.89,173.27,246.3,207.86,203.79,207.86z M299.39,188.62c-2.54,1.49-5.83,0.63-7.32-1.91
              		c-1.49-2.54-0.63-5.83,1.91-7.32c2.54-1.49,5.83-0.63,7.32,1.91C302.79,183.85,301.94,187.13,299.39,188.62z"
                />
              </g>
              <g>
                <path
                  class="st0"
                  d="M82.68,335.46v4.11H70.93v-2.94l5.55-7.63h-5.25v-4.11h11.16v2.93l-5.55,7.64H82.68z"
                />
                <path
                  class="st0"
                  d="M103.34,319.02v20.55h-4.41v-1.38c-0.97,1.12-2.41,1.79-4.37,1.79c-3.85,0-7.02-3.38-7.02-7.75
              		c0-4.38,3.17-7.75,7.02-7.75c1.97,0,3.41,0.68,4.37,1.79v-7.25H103.34z M98.94,332.23c0-2.2-1.47-3.58-3.49-3.58
              		c-2.03,0-3.49,1.38-3.49,3.58s1.47,3.58,3.49,3.58C97.47,335.81,98.94,334.43,98.94,332.23z"
                />
                <path
                  class="st0"
                  d="M119.23,324.6v4.99c-1.82-0.29-4.4,0.44-4.4,3.35v6.63h-4.41v-14.68h4.41v2.61
              		C115.41,325.54,117.38,324.6,119.23,324.6z"
                />
                <path
                  class="st0"
                  d="M123.94,332.23c0-4.38,3.46-7.75,7.78-7.75c4.31,0,7.78,3.38,7.78,7.75c0,4.38-3.46,7.75-7.78,7.75
              		C127.41,339.98,123.94,336.61,123.94,332.23z M135.1,332.23c0-2.09-1.47-3.46-3.38-3.46c-1.91,0-3.38,1.38-3.38,3.46
              		s1.47,3.46,3.38,3.46C133.63,335.7,135.1,334.32,135.1,332.23z"
                />
                <path
                  class="st0"
                  d="M166.1,324.89l-4.7,14.68h-4.11l-2.35-7.84l-2.35,7.84h-4.11l-4.7-14.68h4.7l2.12,7.87l2.29-7.87H157
              		l2.29,7.87l2.11-7.87H166.1z"
                />
                <path
                  class="st0"
                  d="M178.59,336.05c1.2,0,2.23-0.47,2.82-1.12l3.52,2.03c-1.44,1.99-3.61,3.02-6.4,3.02
              		c-5.02,0-8.13-3.38-8.13-7.75c0-4.38,3.17-7.75,7.81-7.75c4.29,0,7.46,3.32,7.46,7.75c0,0.62-0.06,1.2-0.18,1.76h-10.42
              		C175.62,335.52,176.98,336.05,178.59,336.05z M181.29,330.71c-0.47-1.7-1.79-2.32-3.11-2.32c-1.68,0-2.79,0.82-3.2,2.32H181.29z"
                />
                <path
                  class="st0"
                  d="M224.03,324.89l-4.7,14.68h-4.11l-2.35-7.84l-2.35,7.84h-4.11l-4.7-14.68h4.7l2.12,7.87l2.29-7.87h4.11
              		l2.29,7.87l2.11-7.87H224.03z"
                />
                <path
                  class="st0"
                  d="M236.51,336.05c1.2,0,2.23-0.47,2.82-1.12l3.52,2.03c-0.33,0.44-0.68,0.82-1.06,1.17
              		c-1.91,2.06-2.17,3.44-2.17,3.93c0,0.47,0.21,0.76,0.65,0.76c0.18,0.03,0.41-0.03,0.68-0.12v2.64c-0.79,0.33-1.53,0.5-2.58,0.5
              		c-1.61,0-2.93-0.82-2.93-2.67c0-1,0.61-2.17,1.96-3.23c-0.29,0.03-0.61,0.03-0.94,0.03c-5.02,0-8.13-3.38-8.13-7.75
              		c0-4.38,3.17-7.75,7.81-7.75c4.29,0,7.46,3.32,7.46,7.75c0,0.62-0.06,1.2-0.18,1.76h-10.42
              		C233.55,335.52,234.9,336.05,236.51,336.05z M239.21,330.71c-0.47-1.7-1.79-2.32-3.11-2.32c-1.68,0-2.79,0.82-3.2,2.32H239.21z"
                />
                <path
                  class="st0"
                  d="M264.84,319.02v20.55h-4.41v-1.38c-0.97,1.12-2.41,1.79-4.37,1.79c-3.85,0-7.02-3.38-7.02-7.75
              		c0-4.38,3.17-7.75,7.02-7.75c1.96,0,3.41,0.68,4.37,1.79v-7.25H264.84z M260.44,332.23c0-2.2-1.47-3.58-3.49-3.58
              		c-2.03,0-3.49,1.38-3.49,3.58s1.47,3.58,3.49,3.58C258.97,335.81,260.44,334.43,260.44,332.23z"
                />
                <path class="st0" d="M271.92,318.14h4.41v21.43h-4.41V318.14z" />
                <path
                  class="st0"
                  d="M282.95,320.96c0-1.44,1.2-2.64,2.64-2.64s2.64,1.2,2.64,2.64c0,1.44-1.2,2.64-2.64,2.64
              		S282.95,322.4,282.95,320.96z M283.39,324.89h4.41v14.68h-4.41V324.89z"
                />
                <path
                  class="st0"
                  d="M308.95,330.56v9.01h-4.4v-8.37c0-1.82-1.15-2.67-2.55-2.67c-1.62,0-2.73,0.94-2.73,3.03v8.02h-4.41v-14.68
              		h4.41v1.38c0.79-1.09,2.26-1.79,4.2-1.79C306.43,324.48,308.95,326.59,308.95,330.56z"
                />
                <path
                  class="st0"
                  d="M329.47,324.89l-5.02,14.24c-1.64,4.67-4.26,6.52-8.37,6.31v-4.11c2.05,0,3.02-0.64,3.67-2.44l-5.84-14.01
              		h4.84l3.26,8.99l2.76-8.99H329.47z"
                />
              </g>
            </svg>
          </div>
          <div class="col-6" data-aos="fade-up">
            <svg
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 396.46 376.15"
              style="enable-background:new 0 0 396.46 376.15;"
              xml:space="preserve"
            >
              <!-- <style type="text/css">
  .st0 {
    fill: #ffffff;
  }
              </style>-->
              <g>
                <path
                  class="st0"
                  d="M88.57,270.81v24.26H74.29v-21.98c0-6.04-2.89-8.93-7.62-8.93c-2.19,0-4.38,0.96-6.48,3.5
             		c0.09,1.05,0.18,2.1,0.18,3.15v24.26H46.18v-21.98c0-6.04-2.98-8.93-7.62-8.93c-2.19,0-4.29,1.05-6.39,3.76v27.15H17.98v-42.47
             		h14.19v2.54c2.89-2.45,5.87-3.85,10.6-3.85c5.34,0,9.9,2.01,13.05,5.7c4.47-3.94,8.75-5.7,15.06-5.7
             		C81.04,251.28,88.57,258.72,88.57,270.81z"
                />
                <path
                  class="st0"
                  d="M139.81,295.07h-14.19v-2.36c-3.15,2.02-7,3.24-11.65,3.24c-11.47,0-21.11-9.54-21.11-22.15
             		c0-12.7,9.63-22.16,21.11-22.16c4.64,0,8.5,1.22,11.65,3.24v-2.28h14.19V295.07z M125.62,280.35v-13.14
             		c-2.63-3.06-5.69-4.03-8.85-4.03c-5.78,0-9.98,4.73-9.98,10.6c0,5.87,4.2,10.51,9.98,10.51
             		C119.93,284.29,122.99,283.42,125.62,280.35z"
                />
                <path
                  class="st0"
                  d="M180.88,294.28c-5.51,1.75-8.67,2.1-12.87,2.1c-10.25,0-17.08-7.53-17.08-19v-12.61h-8.32v-12.18h8.32v-14.45
             		h14.19v14.45h14.45v12.18h-14.45v12.17c0,4.29,2.46,6.39,6.66,6.39c2.01,0,4.38-0.44,7.53-1.05L180.88,294.28z"
                />
                <path
                  class="st0"
                  d="M217.93,294.28c-5.51,1.75-8.67,2.1-12.87,2.1c-10.25,0-17.08-7.53-17.08-19v-12.61h-8.32v-12.18h8.32v-14.45
             		h14.19v14.45h14.45v12.18h-14.45v12.17c0,4.29,2.46,6.39,6.66,6.39c2.01,0,4.38-0.44,7.53-1.05L217.93,294.28z"
                />
                <path
                  class="st0"
                  d="M266.45,270.81v24.26h-14.28v-21.98c0-6.04-3.06-8.93-7.7-8.93c-2.63,0-5.43,1.49-7.88,4.29v26.62H222.4
             		v-62.18h14.19v22.6c3.42-2.72,7.18-4.21,11.74-4.21C259.1,251.28,266.45,258.72,266.45,270.81z"
                />
                <path
                  class="st0"
                  d="M271.88,237.97c0-4.64,3.68-8.06,8.32-8.06c4.56,0,8.32,3.42,8.32,8.06c0,4.55-3.76,7.97-8.32,7.97
             		C275.56,245.94,271.88,242.52,271.88,237.97z M287.38,295.07H273.2v-42.47h14.19V295.07z"
                />
                <path
                  class="st0"
                  d="M339.41,295.07h-14.19v-2.36c-3.15,2.02-7,3.24-11.65,3.24c-11.47,0-21.11-9.54-21.11-22.15
             		c0-12.7,9.63-22.16,21.11-22.16c4.64,0,8.5,1.22,11.65,3.24v-2.28h14.19V295.07z M325.22,280.35v-13.14
             		c-2.63-3.06-5.69-4.03-8.85-4.03c-5.78,0-9.98,4.73-9.98,10.6c0,5.87,4.2,10.51,9.98,10.51
             		C319.53,284.29,322.59,283.42,325.22,280.35z"
                />
                <path
                  class="st0"
                  d="M356.14,280.53c0.61,3.68,3.68,5.34,8.15,5.34c3.77,0,6.04-1.14,6.04-2.98c0-1.4-1.31-2.54-4.12-2.98
             		l-8.58-1.49c-7.36-1.23-12.43-5.34-12.43-12.78c0-8.94,7.62-14.19,18.91-14.19c9.02,0,19.27,3.5,19.88,14.71h-12.61
             		c-0.26-3.24-3.24-4.73-7.18-4.73c-3.68,0-5.34,1.4-5.34,3.06c0,1.4,1.05,2.72,4.38,3.33l7.97,1.31
             		c7.97,1.49,13.23,5.34,13.23,12.88c0,9.81-8.85,14.36-19.88,14.36c-11.12,0-20.14-4.64-21.02-15.94L356.14,280.53z"
                />
              </g>
              <g>
                <path
                  class="st0"
                  d="M70.03,326.8v4.47H57.26v-3.19l6.03-8.3h-5.71v-4.47h12.13v3.19l-6.03,8.3H70.03z"
                />
                <path
                  class="st0"
                  d="M92.45,308.93v22.34h-4.79v-1.5c-1.05,1.21-2.62,1.95-4.75,1.95c-4.18,0-7.63-3.67-7.63-8.43
             		c0-4.75,3.45-8.42,7.63-8.42c2.14,0,3.7,0.73,4.75,1.95v-7.88H92.45z M87.66,323.29c0-2.39-1.59-3.89-3.8-3.89
             		c-2.2,0-3.8,1.5-3.8,3.89c0,2.39,1.59,3.89,3.8,3.89C86.06,327.18,87.66,325.68,87.66,323.29z"
                />
                <path
                  class="st0"
                  d="M109.66,314.99v5.42c-1.98-0.32-4.79,0.48-4.79,3.64v7.21h-4.79v-15.96h4.79v2.84
             		C105.51,316.01,107.65,314.99,109.66,314.99z"
                />
                <path
                  class="st0"
                  d="M114.75,323.29c0-4.75,3.77-8.42,8.46-8.42c4.69,0,8.46,3.67,8.46,8.42c0,4.76-3.77,8.43-8.46,8.43
             		C118.51,331.71,114.75,328.05,114.75,323.29z M126.88,323.29c0-2.26-1.59-3.76-3.67-3.76s-3.67,1.5-3.67,3.76
             		c0,2.27,1.59,3.77,3.67,3.77S126.88,325.56,126.88,323.29z"
                />
                <path
                  class="st0"
                  d="M160.53,315.31l-5.11,15.96h-4.47l-2.55-8.52l-2.55,8.52h-4.47l-5.11-15.96h5.11l2.3,8.56l2.49-8.56h4.47
             		l2.49,8.56l2.3-8.56H160.53z"
                />
                <path
                  class="st0"
                  d="M174.03,327.44c1.31,0,2.43-0.51,3.06-1.21l3.83,2.2c-1.56,2.17-3.93,3.29-6.96,3.29
             		c-5.46,0-8.84-3.67-8.84-8.43c0-4.75,3.45-8.42,8.49-8.42c4.66,0,8.11,3.6,8.11,8.42c0,0.67-0.06,1.31-0.19,1.92H170.2
             		C170.8,326.86,172.27,327.44,174.03,327.44z M176.97,321.63c-0.51-1.85-1.95-2.52-3.38-2.52c-1.82,0-3.03,0.9-3.48,2.52H176.97z"
                />
                <path
                  class="st0"
                  d="M223.33,315.31l-5.11,15.96h-4.47l-2.55-8.52l-2.55,8.52h-4.47l-5.11-15.96h5.11l2.3,8.56l2.49-8.56h4.47
             		l2.49,8.56l2.3-8.56H223.33z"
                />
                <path
                  class="st0"
                  d="M236.84,327.44c1.31,0,2.43-0.51,3.06-1.21l3.83,2.2c-0.35,0.48-0.73,0.89-1.15,1.27
             		c-2.07,2.23-2.36,3.74-2.36,4.28c0,0.51,0.22,0.83,0.7,0.83c0.19,0.04,0.45-0.03,0.73-0.13v2.87c-0.86,0.35-1.66,0.54-2.81,0.54
             		c-1.76,0-3.19-0.9-3.19-2.9c0-1.09,0.67-2.36,2.14-3.51c-0.32,0.03-0.67,0.03-1.02,0.03c-5.46,0-8.84-3.67-8.84-8.43
             		c0-4.75,3.45-8.42,8.49-8.42c4.66,0,8.11,3.6,8.11,8.42c0,0.67-0.06,1.31-0.19,1.92h-11.33
             		C233.61,326.86,235.08,327.44,236.84,327.44z M239.77,321.63c-0.51-1.85-1.95-2.52-3.38-2.52c-1.82,0-3.03,0.9-3.48,2.52H239.77z"
                />
                <path
                  class="st0"
                  d="M267.58,308.93v22.34h-4.79v-1.5c-1.05,1.21-2.62,1.95-4.75,1.95c-4.18,0-7.63-3.67-7.63-8.43
             		c0-4.75,3.45-8.42,7.63-8.42c2.14,0,3.7,0.73,4.75,1.95v-7.88H267.58z M262.79,323.29c0-2.39-1.59-3.89-3.8-3.89
             		c-2.2,0-3.8,1.5-3.8,3.89c0,2.39,1.59,3.89,3.8,3.89C261.2,327.18,262.79,325.68,262.79,323.29z"
                />
                <path class="st0" d="M275.21,307.97H280v23.3h-4.79V307.97z" />
                <path
                  class="st0"
                  d="M287.17,311.03c0-1.56,1.31-2.87,2.87-2.87c1.56,0,2.87,1.31,2.87,2.87s-1.31,2.87-2.87,2.87
             		C288.48,313.9,287.17,312.6,287.17,311.03z M287.65,315.31h4.79v15.96h-4.79V315.31z"
                />
                <path
                  class="st0"
                  d="M315.4,321.47v9.8h-4.79v-9.1c0-1.98-1.25-2.9-2.78-2.9c-1.76,0-2.97,1.02-2.97,3.29v8.71h-4.79v-15.96h4.79
             		v1.5c0.86-1.18,2.46-1.95,4.56-1.95C312.66,314.86,315.4,317.16,315.4,321.47z"
                />
                <path
                  class="st0"
                  d="M337.65,315.31l-5.46,15.48c-1.79,5.08-4.63,7.08-9.1,6.86v-4.47c2.23,0,3.29-0.7,3.99-2.65l-6.35-15.22H326
             		l3.54,9.77l3-9.77H337.65z"
                />
              </g>
              <g>
                <path
                  class="st0"
                  d="M200.62,118.43c-19.96,0-36.19,12.43-36.19,27.71c0,15.28,16.24,27.71,36.19,27.71
             		c19.96,0,36.2-12.43,36.2-27.71C236.82,130.86,220.58,118.43,200.62,118.43z M200.62,162.16c-13.28,0-24.5-7.34-24.5-16.02
             		c0-8.69,11.22-16.02,24.5-16.02c13.28,0,24.51,7.34,24.51,16.02C225.13,154.83,213.91,162.16,200.62,162.16z"
                />
                <path
                  class="st0"
                  d="M176.17,117.53c4.25,0,7.71-3.46,7.71-7.7c0-4.25-3.46-7.71-7.71-7.71c-4.25,0-7.71,3.46-7.71,7.71
             		C168.46,114.08,171.92,117.53,176.17,117.53z"
                />
                <path
                  class="st0"
                  d="M225.08,117.53c4.25,0,7.7-3.46,7.7-7.7c0-4.25-3.46-7.71-7.7-7.71c-4.25,0-7.71,3.46-7.71,7.71
             		C217.38,114.08,220.83,117.53,225.08,117.53z"
                />
                <path
                  class="st0"
                  d="M193.16,134.71c-2.63,0-4.76,2.15-4.76,4.78v13.3c0,2.64,2.14,4.78,4.76,4.78s4.76-2.14,4.76-4.78v-13.3
             		C197.92,136.86,195.79,134.71,193.16,134.71z"
                />
                <path
                  class="st0"
                  d="M208.18,134.71c-2.63,0-4.76,2.15-4.76,4.78v13.3c0,2.64,2.14,4.78,4.76,4.78c2.63,0,4.76-2.14,4.76-4.78
             		v-13.3C212.95,136.86,210.81,134.71,208.18,134.71z"
                />
                <path
                  class="st0"
                  d="M314.67,182.99c-1.46-2.48-4.65-3.32-7.13-1.86c-1.58,0.92-3.25,1.54-4.95,1.86
             		c4.15-4.93,4.98-12.13,1.54-17.99c-4.36-7.44-13.96-9.95-21.4-5.59c-7.44,4.36-9.95,13.96-5.59,21.4c0.14,0.23,0.28,0.46,0.42,0.68
             		c0.65,1.03,1.36,2.01,2.12,2.92c-5.54,1.11-11.53-0.91-15.34-5.33c13.92-15.39,22.41-35.78,22.41-58.11
             		c0-14.66-3.67-28.47-10.11-40.58l-0.26-5.01c-1.49-28.88-10.55-39.95-11.57-41.12l-2.27-2.58l-3.35,0.77
             		c-0.52,0.12-11.59,2.78-18.67,11.86c-12.1-6.42-25.88-10.07-40.5-10.07c-15.58,0-30.19,4.15-42.84,11.37
             		c-6.99-10.14-19.08-13.04-19.63-13.16l-3.35-0.77l-2.27,2.58c-1.03,1.17-10.09,12.24-11.57,41.12l-0.67,12.97
             		c-4.11,10.08-6.39,21.09-6.39,32.63c0,47.82,38.91,86.73,86.73,86.73c21.73,0,41.61-8.05,56.85-21.31
             		c3.38,3.76,7.76,6.49,12.76,7.85c6.83,1.87,13.9,0.95,19.91-2.57l0.01-0.01c7.31,3.05,15.91,2.76,23.25-1.54
             		C315.29,188.67,316.13,185.48,314.67,182.99z M250.76,50.06c2.3-2.41,5.09-4.01,7.29-5.01c1.54,3.02,3.66,8.29,5.16,16.38
             		c-0.45-0.4-0.92-0.83-1.38-1.24c-2.31-2.35-4.75-4.56-7.31-6.64C253.2,52.35,251.92,51.17,250.76,50.06z M138.69,45.05
             		c2.2,0.99,4.99,2.59,7.29,5.01c-3.68,3.49-8.29,7.66-12.45,11.38C135.04,53.33,137.17,48.05,138.69,45.05z M200.03,196.16
             		c-41.46,0-75.19-33.73-75.19-75.19c0-28.26,15.68-52.92,38.79-65.76l15.48,9.21c0,0-2.77-8.8-3.86-12.7l22.42,18.7l-3.45-17.92
             		l42.67,30.76l-6.85-31.2c6.09,2.66,11.75,6.11,16.87,10.21c2.28,2.1,4.68,4.27,6.99,6.35c13.18,13.55,21.31,32.02,21.31,52.37
             		C275.22,162.43,241.49,196.16,200.03,196.16z M293.27,177.41c-2.48,1.45-5.68,0.62-7.13-1.86c-1.45-2.48-0.62-5.68,1.86-7.13
             		c2.48-1.45,5.68-0.62,7.13,1.86C296.58,172.75,295.75,175.95,293.27,177.41z"
                />
              </g>
            </svg>
          </div>
          <div class="col-6" data-aos="fade-up">
            <svg
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 396.46 376.15"
              style="enable-background:new 0 0 396.46 376.15;"
              xml:space="preserve"
            >
              <!-- <style type="text/css">
  .st0 {
    fill: #ffffff;
  }
              </style>-->
              <g>
                <path
                  class="st0"
                  d="M76.35,339.58v3.6H66.06v-2.57l4.86-6.69h-4.6v-3.6h9.77v2.57l-4.86,6.69H76.35z"
                />
                <path
                  class="st0"
                  d="M98.28,325.17v18.01h-3.86v-1.2c-0.85,0.97-2.11,1.57-3.84,1.57c-3.37,0-6.15-2.96-6.15-6.79
              		c0-3.83,2.78-6.79,6.15-6.79c1.72,0,2.98,0.59,3.84,1.57v-6.36H98.28z M94.42,336.74c0-1.93-1.29-3.14-3.06-3.14
              		c-1.78,0-3.06,1.21-3.06,3.14c0,1.93,1.29,3.14,3.06,3.14C93.13,339.88,94.42,338.68,94.42,336.74z"
                />
                <path
                  class="st0"
                  d="M116.01,330.06v4.37c-1.6-0.26-3.86,0.39-3.86,2.93v5.81h-3.86v-12.86h3.86v2.29
              		C112.66,330.88,114.39,330.06,116.01,330.06z"
                />
                <path
                  class="st0"
                  d="M123.97,336.74c0-3.83,3.03-6.79,6.82-6.79c3.78,0,6.82,2.96,6.82,6.79c0,3.84-3.04,6.79-6.82,6.79
              		C127.01,343.54,123.97,340.58,123.97,336.74z M133.75,336.74c0-1.82-1.29-3.04-2.96-3.04s-2.96,1.21-2.96,3.04
              		c0,1.83,1.29,3.04,2.96,3.04S133.75,338.57,133.75,336.74z"
                />
                <path
                  class="st0"
                  d="M164.73,330.31l-4.12,12.86h-3.6l-2.06-6.87l-2.06,6.87h-3.6l-4.12-12.86h4.12l1.85,6.9l2.01-6.9h3.6l2.01,6.9
              		l1.85-6.9H164.73z"
                />
                <path
                  class="st0"
                  d="M179.47,340.09c1.05,0,1.96-0.41,2.47-0.98l3.09,1.77c-1.26,1.75-3.16,2.65-5.61,2.65
              		c-4.4,0-7.13-2.96-7.13-6.79c0-3.83,2.78-6.79,6.85-6.79c3.76,0,6.53,2.91,6.53,6.79c0,0.54-0.05,1.06-0.15,1.55h-9.13
              		C176.87,339.63,178.06,340.09,179.47,340.09z M181.84,335.41c-0.41-1.49-1.57-2.03-2.73-2.03c-1.47,0-2.44,0.72-2.8,2.03H181.84z"
                />
                <path
                  class="st0"
                  d="M226.93,330.31l-4.12,12.86h-3.6l-2.06-6.87l-2.06,6.87h-3.6l-4.12-12.86h4.12l1.85,6.9l2.01-6.9h3.6l2.01,6.9
              		l1.85-6.9H226.93z"
                />
                <path
                  class="st0"
                  d="M241.68,340.09c1.06,0,1.96-0.41,2.47-0.98l3.09,1.77c-0.28,0.39-0.59,0.72-0.93,1.03
              		c-1.67,1.8-1.9,3.01-1.9,3.44c0,0.41,0.18,0.67,0.56,0.67c0.16,0.02,0.36-0.03,0.59-0.11v2.31c-0.7,0.28-1.34,0.44-2.26,0.44
              		c-1.42,0-2.57-0.72-2.57-2.34c0-0.88,0.54-1.9,1.72-2.83c-0.26,0.03-0.54,0.03-0.82,0.03c-4.4,0-7.13-2.96-7.13-6.79
              		c0-3.83,2.78-6.79,6.84-6.79c3.76,0,6.54,2.91,6.54,6.79c0,0.54-0.05,1.06-0.16,1.55h-9.13
              		C239.08,339.63,240.26,340.09,241.68,340.09z M244.04,335.41c-0.41-1.49-1.57-2.03-2.73-2.03c-1.47,0-2.44,0.72-2.81,2.03H244.04z"
                />
                <path
                  class="st0"
                  d="M270.32,325.17v18.01h-3.86v-1.2c-0.85,0.97-2.11,1.57-3.84,1.57c-3.37,0-6.15-2.96-6.15-6.79
              		c0-3.83,2.78-6.79,6.15-6.79c1.72,0,2.98,0.59,3.84,1.57v-6.36H270.32z M266.46,336.74c0-1.93-1.29-3.14-3.06-3.14
              		c-1.78,0-3.06,1.21-3.06,3.14c0,1.93,1.29,3.14,3.06,3.14C265.17,339.88,266.46,338.68,266.46,336.74z"
                />
                <path class="st0" d="M280.33,324.39h3.86v18.78h-3.86V324.39z" />
                <path
                  class="st0"
                  d="M293.82,326.86c0-1.26,1.05-2.31,2.32-2.31c1.26,0,2.31,1.05,2.31,2.31c0,1.26-1.05,2.31-2.31,2.31
              		C294.88,329.18,293.82,328.12,293.82,326.86z M294.21,330.31h3.86v12.86h-3.86V330.31z"
                />
                <path
                  class="st0"
                  d="M320.44,335.28v7.9h-3.86v-7.33c0-1.6-1-2.34-2.24-2.34c-1.42,0-2.39,0.82-2.39,2.65v7.02h-3.86v-12.86h3.86
              		v1.21c0.7-0.95,1.98-1.57,3.68-1.57C318.23,329.95,320.44,331.8,320.44,335.28z"
                />
                <path
                  class="st0"
                  d="M342.24,330.31l-4.4,12.48c-1.44,4.09-3.73,5.71-7.33,5.53v-3.6c1.8,0,2.65-0.57,3.22-2.14l-5.12-12.27h4.24
              		l2.86,7.87l2.42-7.87H342.24z"
                />
              </g>
              <g>
                <g>
                  <g>
                    <g>
                      <g>
                        <path
                          class="st0"
                          d="M207.89,180.83c-22.19,0-40.24-13.82-40.24-30.81s18.05-30.81,40.24-30.81
              						c22.19,0,40.24,13.82,40.24,30.81S230.08,180.83,207.89,180.83z M207.89,132.2c-14.77,0-27.24,8.16-27.24,17.81
              						s12.47,17.81,27.24,17.81c14.77,0,27.24-8.16,27.24-17.81S222.66,132.2,207.89,132.2z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          class="st0"
                          d="M180.7,118.21c-4.72,0-8.57-3.84-8.57-8.56c0-4.72,3.84-8.57,8.57-8.57c4.72,0,8.57,3.84,8.57,8.57
              						C189.27,114.37,185.43,118.21,180.7,118.21z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <path
                          class="st0"
                          d="M235.08,118.21c-4.72,0-8.57-3.84-8.57-8.56c0-4.72,3.84-8.57,8.57-8.57c4.72,0,8.57,3.84,8.57,8.57
              						C243.65,114.37,239.81,118.21,235.08,118.21z"
                        />
                      </g>
                    </g>
                    <g>
                      <g>
                        <g>
                          <path
                            class="st0"
                            d="M199.59,162.72c-2.92,0-5.29-2.38-5.29-5.31v-14.78c0-2.93,2.37-5.32,5.29-5.32c2.92,0,5.3,2.38,5.3,5.32
              							v14.78C204.89,160.34,202.51,162.72,199.59,162.72z"
                          />
                        </g>
                      </g>
                    </g>
                    <g>
                      <g>
                        <g>
                          <path
                            class="st0"
                            d="M216.3,162.72c-2.92,0-5.29-2.38-5.29-5.31v-14.78c0-2.93,2.37-5.32,5.29-5.32c2.92,0,5.3,2.38,5.3,5.32
              							v14.78C221.59,160.34,219.22,162.72,216.3,162.72z"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <path
                  class="st0"
                  d="M207.23,221.01c-53.17,0-96.42-43.25-96.42-96.42s43.25-96.42,96.42-96.42s96.42,43.25,96.42,96.42
              		S260.39,221.01,207.23,221.01z M207.23,40.99c-46.09,0-83.59,37.5-83.59,83.59c0,46.09,37.5,83.59,83.59,83.59
              		s83.59-37.5,83.59-83.59C290.82,78.49,253.32,40.99,207.23,40.99z"
                />
              </g>
              <g>
                <g>
                  <path
                    class="st0"
                    d="M206.22,195.01c-4.14,0-8.44-0.6-13.15-1.82c-0.97-0.25-1.75-0.92-2.21-1.88c-0.54-1.14-0.55-2.57-0.02-3.73
              			c0.67-1.49,2.12-2.38,3.88-2.38c0.52,0,1.06,0.08,1.58,0.24c2.36,0.71,5.5,1.09,9.09,1.09c4.4,0,9.26-0.61,11.82-1.48
              			c0.35-0.12,0.71-0.18,1.07-0.18c1.85,0,3.57,1.57,3.92,3.57c0.08,0.48,0.08,0.96,0,1.43c-0.3,1.71-1.63,3.05-3.4,3.42
              			c-0.43,0.09-0.87,0.19-1.33,0.29C214.55,194.22,210.95,195.01,206.22,195.01z"
                  />
                </g>
              </g>
              <path
                class="st0"
                d="M120.9,84.87l0.75-14.63c1.6-31.17,11.38-43.13,12.49-44.38l2.45-2.79l3.62,0.83
              	c0.64,0.15,15.65,3.73,22.76,16.75l2.24,4.09l-3.3,3.3c-8.95,8.95-29.11,26.48-29.96,27.22L120.9,84.87z M141.45,37.51
              	c-1.64,3.24-3.94,8.93-5.57,17.69c4.49-4.01,9.46-8.51,13.44-12.28C146.84,40.31,143.82,38.58,141.45,37.51z"
              />
              <path
                class="st0"
                d="M290.82,84.87l-11.06-9.6c-0.85-0.74-21.01-18.27-29.96-27.22l-3.3-3.3l2.24-4.09
              	c7.12-13.02,22.13-16.61,22.76-16.75l3.62-0.83l2.45,2.79c1.11,1.26,10.89,13.21,12.49,44.38L290.82,84.87z M262.4,42.92
              	c3.98,3.77,8.95,8.27,13.44,12.28c-1.62-8.73-3.92-14.42-5.57-17.69C267.9,38.59,264.89,40.31,262.4,42.92z"
              />
              <g>
                <path
                  class="st0"
                  d="M23.97,265.84h11.77l1.04,6.25h0.36c4-4.02,8.36-7.43,14.75-7.43c6.85,0,10.98,2.96,13.44,8.2
              		c4.28-4.47,8.85-8.2,15.28-8.2c10.52,0,15.23,7.47,15.23,19.64v30.23H81.42v-28.38c0-7-1.91-9.2-6.01-9.2
              		c-2.44,0-5.22,1.53-8.29,4.73v32.84H52.7v-28.38c0-7-1.92-9.2-6.01-9.2c-2.41,0-5.22,1.53-8.28,4.73v32.84H23.97V265.84z"
                />
                <path
                  class="st0"
                  d="M102.92,301.02c0-10.26,8.16-15.81,27.42-17.84c-0.29-4.26-2.41-7.04-7.7-7.04c-4.08,0-8.16,1.72-12.88,4.4
              		l-5.13-9.47c6.18-3.78,13.14-6.41,20.79-6.41c12.45,0,19.34,7.11,19.34,22.03v27.83h-11.77l-1.04-4.99h-0.36
              		c-4.1,3.6-8.7,6.16-14.17,6.16C108.55,315.7,102.92,309.22,102.92,301.02z M130.34,300.38v-8.5c-10.26,1.39-13.61,4.32-13.61,8
              		c0,3.14,2.16,4.67,5.58,4.67C125.58,304.54,127.78,302.93,130.34,300.38z"
                />
                <path
                  class="st0"
                  d="M154.13,296.82v-19.66h-6.65v-10.77l7.46-0.55l1.69-12.93h11.93v12.93h11.67v11.32h-11.67v19.49
              		c0,5.52,2.51,7.74,6.3,7.74c1.61,0,3.35-0.46,4.63-0.92l2.27,10.47c-2.59,0.82-6.09,1.77-10.82,1.77
              		C158.92,315.7,154.13,308.1,154.13,296.82z"
                />
                <path
                  class="st0"
                  d="M186.83,296.82v-19.66h-6.65v-10.77l7.46-0.55l1.69-12.93h11.93v12.93h11.67v11.32h-11.67v19.49
              		c0,5.52,2.51,7.74,6.3,7.74c1.61,0,3.35-0.46,4.63-0.92l2.27,10.47c-2.59,0.82-6.09,1.77-10.82,1.77
              		C191.61,315.7,186.83,308.1,186.83,296.82z"
                />
                <path
                  class="st0"
                  d="M219.52,245.78h14.43v16.79l-0.65,8.82c3.65-3.32,8.39-6.73,15.03-6.73c10.59,0,15.1,7.47,15.1,19.64v30.23
              		h-14.42v-28.38c0-7-1.88-9.2-6.05-9.2c-3.62,0-5.84,1.69-9.01,4.73v32.84h-14.43V245.78z"
                />
                <path
                  class="st0"
                  d="M271.52,251.18c0-4.42,3.51-7.55,8.35-7.55c4.83,0,8.35,3.12,8.35,7.55c0,4.39-3.51,7.54-8.35,7.54
              		C275.03,258.72,271.52,255.57,271.52,251.18z M272.64,265.84h14.43v48.69h-14.43V265.84z"
                />
                <path
                  class="st0"
                  d="M294.54,301.02c0-10.26,8.16-15.81,27.42-17.84c-0.29-4.26-2.41-7.04-7.7-7.04c-4.08,0-8.16,1.72-12.88,4.4
              		l-5.13-9.47c6.18-3.78,13.14-6.41,20.79-6.41c12.45,0,19.34,7.11,19.34,22.03v27.83h-11.77l-1.04-4.99h-0.36
              		c-4.1,3.6-8.7,6.16-14.17,6.16C300.18,315.7,294.54,309.22,294.54,301.02z M321.97,300.38v-8.5c-10.26,1.39-13.61,4.32-13.61,8
              		c0,3.14,2.16,4.67,5.58,4.67C317.21,304.54,319.4,302.93,321.97,300.38z"
                />
                <path
                  class="st0"
                  d="M341.27,308.9l6.49-8.99c4.41,3.34,8.48,5.12,12.56,5.12c4.3,0,6.15-1.64,6.15-4.19
              		c0-3.21-4.82-4.66-9.83-6.62c-5.97-2.31-12.89-6.27-12.89-14.32c0-9.06,7.37-15.24,18.6-15.24c7.46,0,13.01,3.02,17.16,6.17
              		l-6.46,8.66c-3.46-2.52-6.88-4.16-10.25-4.16c-3.73,0-5.56,1.46-5.56,3.89c0,3.1,4.56,4.29,9.6,6.12
              		c6.16,2.28,13.12,5.75,13.12,14.65c0,8.81-6.95,15.7-20,15.7C353.55,315.7,346.2,312.92,341.27,308.9z"
                />
              </g>
            </svg>
          </div>
          <div class="col-6" data-aos="fade-up">
            <svg
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 396.46 376.15"
              style="enable-background:new 0 0 396.46 376.15;"
              xml:space="preserve"
            >
              <!-- <style type="text/css">
  .st0 {
    fill: #ffffff;
  }
              </style>-->
              <g>
                <path
                  class="st0"
                  d="M198.74,131.29c-20.6,0-37.36,12.83-37.36,28.61c0,15.77,16.76,28.61,37.36,28.61
             		c20.6,0,37.36-12.83,37.36-28.61C236.1,144.13,219.34,131.29,198.74,131.29z M198.74,176.44c-13.71,0-25.29-7.57-25.29-16.54
             		s11.58-16.54,25.29-16.54c13.71,0,25.3,7.57,25.3,16.54S212.45,176.44,198.74,176.44z"
                />
                <path
                  class="st0"
                  d="M173.49,125.59c4.39,0,7.96-3.57,7.96-7.95c0-4.39-3.57-7.96-7.96-7.96c-4.39,0-7.95,3.57-7.95,7.96
             		C165.54,122.02,169.11,125.59,173.49,125.59z"
                />
                <path
                  class="st0"
                  d="M223.99,125.59c4.39,0,7.95-3.57,7.95-7.95c0-4.39-3.57-7.96-7.95-7.96c-4.39,0-7.96,3.57-7.96,7.96
             		C216.03,122.02,219.6,125.59,223.99,125.59z"
                />
                <path
                  class="st0"
                  d="M191.03,148.1c-2.71,0-4.92,2.21-4.92,4.94v13.73c0,2.72,2.2,4.93,4.92,4.93c2.71,0,4.92-2.21,4.92-4.93
             		v-13.73C195.95,150.32,193.74,148.1,191.03,148.1z"
                />
                <path
                  class="st0"
                  d="M206.54,148.1c-2.71,0-4.92,2.21-4.92,4.94v13.73c0,2.72,2.2,4.93,4.92,4.93s4.92-2.21,4.92-4.93v-13.73
             		C211.46,150.32,209.25,148.1,206.54,148.1z"
                />
                <path
                  class="st0"
                  d="M316.47,195.51c-1.5-2.56-4.8-3.42-7.37-1.92c-1.63,0.95-3.36,1.59-5.11,1.92c4.28-5.08,5.14-12.52,1.59-18.58
             		c-4.5-7.68-14.41-10.27-22.1-5.77c-7.68,4.5-10.27,14.41-5.77,22.1c0.14,0.24,0.29,0.47,0.44,0.71c0.67,1.07,1.4,2.07,2.19,3.01
             		c-5.72,1.15-11.91-0.94-15.83-5.51c14.37-15.89,23.13-36.93,23.13-59.99c0-16.22-4.36-31.43-11.93-44.56l-0.2-3.94
             		c-2.07-40.29-30.71-55.01-31.93-55.62l-8.61-4.29v26.85c-11.25-5.1-23.72-7.97-36.86-7.97c-13.25,0-25.83,2.92-37.15,8.1V23.08
             		l-8.61,4.29c-1.22,0.61-29.86,15.33-31.93,55.62l-0.23,4.5c-7.37,13-11.6,28.01-11.6,44c0,49.37,40.16,89.53,89.53,89.53
             		c22.44,0,42.96-8.31,58.68-22c3.48,3.88,8.01,6.7,13.17,8.11c7.05,1.93,14.35,0.98,20.55-2.65l0.01-0.01
             		c7.54,3.15,16.43,2.85,24-1.59C317.11,201.37,317.97,198.07,316.47,195.51z M246.89,44.53c4.63,4.46,10.07,11.42,13.49,21.52
             		c-4.43-4.01-9.28-8.07-13.49-10.83V44.53z M149.06,44.52v10.69c-4.21,2.76-9.06,6.82-13.49,10.83
             		C138.98,55.94,144.42,48.98,149.06,44.52z M198.12,209.1c-42.8,0-77.62-34.82-77.62-77.62c0-33.28,21.05-61.72,50.54-72.74
             		l29.43,15.76l-5.15-14.01l40.85,22.48l-7.07-22.65c27.42,11.99,46.64,39.36,46.64,71.15C275.74,174.28,240.92,209.1,198.12,209.1z
             		 M294.37,189.74c-2.56,1.5-5.86,0.64-7.37-1.92c-1.5-2.56-0.64-5.86,1.92-7.37c2.56-1.5,5.86-0.64,7.37,1.92
             		C297.8,184.94,296.93,188.24,294.37,189.74z"
                />
              </g>
              <g>
                <path
                  class="st0"
                  d="M78.22,337.57v4.14H66.38v-2.96l5.59-7.69h-5.3v-4.14h11.24v2.96l-5.59,7.69H78.22z"
                />
                <path
                  class="st0"
                  d="M99.02,321v20.71h-4.44v-1.39c-0.98,1.12-2.43,1.8-4.41,1.8c-3.88,0-7.07-3.4-7.07-7.81s3.19-7.81,7.07-7.81
             		c1.98,0,3.43,0.68,4.41,1.81V321H99.02z M94.59,334.31c0-2.22-1.48-3.61-3.52-3.61c-2.04,0-3.52,1.39-3.52,3.61
             		c0,2.22,1.48,3.61,3.52,3.61C93.11,337.92,94.59,336.53,94.59,334.31z"
                />
                <path
                  class="st0"
                  d="M115.01,326.62v5.03c-1.83-0.3-4.44,0.45-4.44,3.37v6.69h-4.44v-14.79h4.44v2.63
             		C111.17,327.57,113.15,326.62,115.01,326.62z"
                />
                <path
                  class="st0"
                  d="M119.75,334.31c0-4.41,3.49-7.81,7.84-7.81c4.35,0,7.84,3.4,7.84,7.81s-3.49,7.81-7.84,7.81
             		C123.24,342.12,119.75,338.72,119.75,334.31z M130.99,334.31c0-2.1-1.48-3.49-3.4-3.49c-1.92,0-3.41,1.39-3.41,3.49
             		c0,2.1,1.48,3.49,3.41,3.49C129.51,337.8,130.99,336.41,130.99,334.31z"
                />
                <path
                  class="st0"
                  d="M162.22,326.92l-4.74,14.79h-4.14l-2.37-7.9l-2.37,7.9h-4.14l-4.74-14.79h4.74l2.13,7.93l2.31-7.93h4.14
             		l2.31,7.93l2.13-7.93H162.22z"
                />
                <path
                  class="st0"
                  d="M174.77,338.16c1.21,0,2.25-0.47,2.84-1.13l3.55,2.04c-1.45,2.01-3.64,3.05-6.45,3.05
             		c-5.06,0-8.19-3.4-8.19-7.81s3.19-7.81,7.87-7.81c4.32,0,7.51,3.34,7.51,7.81c0,0.62-0.06,1.21-0.18,1.77h-10.5
             		C171.79,337.62,173.15,338.16,174.77,338.16z M177.5,332.77c-0.47-1.72-1.81-2.34-3.14-2.34c-1.69,0-2.81,0.83-3.22,2.34H177.5z"
                />
                <path
                  class="st0"
                  d="M220.53,326.92l-4.74,14.79h-4.14l-2.37-7.9l-2.37,7.9h-4.14l-4.74-14.79h4.74l2.13,7.93l2.31-7.93h4.14
             		l2.31,7.93l2.13-7.93H220.53z"
                />
                <path
                  class="st0"
                  d="M233.09,338.16c1.21,0,2.25-0.47,2.84-1.13l3.55,2.04c-0.33,0.44-0.68,0.83-1.07,1.18
             		c-1.92,2.07-2.19,3.46-2.19,3.97c0,0.47,0.21,0.77,0.65,0.77c0.18,0.03,0.42-0.03,0.68-0.12v2.66c-0.8,0.33-1.54,0.5-2.61,0.5
             		c-1.62,0-2.95-0.83-2.95-2.69c0-1.01,0.62-2.19,1.98-3.26c-0.3,0.03-0.62,0.03-0.95,0.03c-5.06,0-8.19-3.4-8.19-7.81
             		s3.19-7.81,7.87-7.81c4.32,0,7.51,3.34,7.51,7.81c0,0.62-0.06,1.21-0.18,1.77h-10.5C230.1,337.62,231.46,338.16,233.09,338.16z
             		 M235.81,332.77c-0.47-1.72-1.81-2.34-3.14-2.34c-1.69,0-2.81,0.83-3.22,2.34H235.81z"
                />
                <path
                  class="st0"
                  d="M261.62,321v20.71h-4.44v-1.39c-0.98,1.12-2.43,1.8-4.41,1.8c-3.88,0-7.07-3.4-7.07-7.81s3.19-7.81,7.07-7.81
             		c1.98,0,3.43,0.68,4.41,1.81V321H261.62z M257.18,334.31c0-2.22-1.48-3.61-3.52-3.61s-3.52,1.39-3.52,3.61
             		c0,2.22,1.48,3.61,3.52,3.61S257.18,336.53,257.18,334.31z"
                />
                <path class="st0" d="M268.73,320.11h4.44v21.59h-4.44V320.11z" />
                <path
                  class="st0"
                  d="M279.83,322.95c0-1.45,1.21-2.66,2.66-2.66s2.66,1.21,2.66,2.66c0,1.45-1.21,2.66-2.66,2.66
             		S279.83,324.4,279.83,322.95z M280.28,326.92h4.44v14.79h-4.44V326.92z"
                />
                <path
                  class="st0"
                  d="M306.02,332.62v9.08h-4.44v-8.43c0-1.83-1.15-2.69-2.57-2.69c-1.63,0-2.75,0.95-2.75,3.05v8.08h-4.44v-14.79
             		h4.44v1.39c0.8-1.1,2.27-1.81,4.23-1.81C303.47,326.5,306.02,328.63,306.02,332.62z"
                />
                <path
                  class="st0"
                  d="M326.68,326.92l-5.06,14.35c-1.66,4.7-4.29,6.57-8.43,6.36v-4.14c2.07,0,3.05-0.65,3.7-2.46L311,326.92h4.88
             		l3.28,9.05l2.78-9.05H326.68z"
                />
              </g>
              <path
                class="st0"
                d="M220.99,56.02c0.26,1.09,8.27,15.7,8.27,15.7l-32.72-11.59L220.99,56.02z"
              />
              <g>
                <path
                  class="st0"
                  d="M27.47,262.39h11.47l1.01,6.09h0.35c3.89-3.92,8.15-7.24,14.38-7.24c6.67,0,10.7,2.88,13.1,7.99
             		c4.17-4.35,8.63-7.99,14.89-7.99c10.25,0,14.84,7.28,14.84,19.14v29.45H83.45v-27.65c0-6.83-1.86-8.96-5.86-8.96
             		c-2.38,0-5.08,1.48-8.08,4.61v32.01H55.46v-27.65c0-6.83-1.87-8.96-5.86-8.96c-2.35,0-5.08,1.48-8.07,4.61v32.01H27.47V262.39z"
                />
                <path
                  class="st0"
                  d="M104.4,296.67c0-10,7.95-15.41,26.72-17.39c-0.28-4.15-2.35-6.86-7.5-6.86c-3.98,0-7.95,1.68-12.55,4.29
             		l-5-9.23c6.02-3.68,12.8-6.24,20.26-6.24c12.13,0,18.85,6.93,18.85,21.47v27.12h-11.47l-1.01-4.86h-0.35
             		c-4,3.51-8.47,6.01-13.81,6.01C109.89,310.98,104.4,304.67,104.4,296.67z M131.12,296.05v-8.29c-10,1.35-13.26,4.21-13.26,7.79
             		c0,3.06,2.1,4.55,5.44,4.55C126.49,300.11,128.62,298.53,131.12,296.05z"
                />
                <path
                  class="st0"
                  d="M154.31,292.58v-19.16h-6.48v-10.49l7.26-0.54l1.64-12.6h11.63v12.6h11.37v11.03h-11.37v18.99
             		c0,5.38,2.44,7.54,6.14,7.54c1.57,0,3.26-0.45,4.51-0.9l2.22,10.21c-2.52,0.8-5.94,1.72-10.54,1.72
             		C158.97,310.98,154.31,303.57,154.31,292.58z"
                />
                <path
                  class="st0"
                  d="M186.17,292.58v-19.16h-6.48v-10.49l7.26-0.54l1.64-12.6h11.63v12.6h11.37v11.03h-11.37v18.99
             		c0,5.38,2.44,7.54,6.14,7.54c1.57,0,3.26-0.45,4.51-0.9l2.22,10.21c-2.52,0.8-5.94,1.72-10.54,1.72
             		C190.83,310.98,186.17,303.57,186.17,292.58z"
                />
                <path
                  class="st0"
                  d="M218.03,242.84h14.06v16.37l-0.63,8.59c3.56-3.24,8.18-6.56,14.65-6.56c10.32,0,14.72,7.28,14.72,19.14v29.45
             		h-14.06v-27.65c0-6.83-1.83-8.96-5.9-8.96c-3.53,0-5.69,1.64-8.78,4.61v32.01h-14.06V242.84z"
                />
                <path
                  class="st0"
                  d="M268.69,248.1c0-4.31,3.42-7.35,8.14-7.35c4.71,0,8.14,3.04,8.14,7.35c0,4.28-3.42,7.35-8.14,7.35
             		C272.12,255.45,268.69,252.38,268.69,248.1z M269.78,262.39h14.06v47.44h-14.06V262.39z"
                />
                <path
                  class="st0"
                  d="M291.13,296.67c0-10,7.95-15.41,26.72-17.39c-0.28-4.15-2.35-6.86-7.5-6.86c-3.98,0-7.95,1.68-12.55,4.29
             		l-4.99-9.23c6.02-3.68,12.8-6.24,20.26-6.24c12.13,0,18.85,6.93,18.85,21.47v27.12h-11.47l-1.01-4.86h-0.35
             		c-4,3.51-8.47,6.01-13.81,6.01C296.63,310.98,291.13,304.67,291.13,296.67z M317.86,296.05v-8.29c-10,1.35-13.26,4.21-13.26,7.79
             		c0,3.06,2.1,4.55,5.44,4.55C313.22,300.11,315.36,298.53,317.86,296.05z"
                />
                <path
                  class="st0"
                  d="M336.67,304.35l6.33-8.75c4.3,3.25,8.27,4.98,12.24,4.98c4.19,0,6-1.6,6-4.08c0-3.13-4.7-4.54-9.58-6.46
             		c-5.82-2.25-12.56-6.11-12.56-13.95c0-8.83,7.18-14.85,18.13-14.85c7.27,0,12.68,2.94,16.72,6.01l-6.29,8.44
             		c-3.38-2.45-6.7-4.05-9.99-4.05c-3.63,0-5.42,1.42-5.42,3.79c0,3.02,4.45,4.18,9.36,5.97c6.01,2.22,12.78,5.6,12.78,14.28
             		c0,8.58-6.78,15.3-19.49,15.3C348.63,310.98,341.48,308.27,336.67,304.35z"
                />
              </g>
            </svg>
          </div>
          <div data-aos="fade-up" class="col-6">
            <svg
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 396.46 376.15"
              style="enable-background:new 0 0 396.46 376.15;"
              xml:space="preserve"
            >
              <!-- <style type="text/css">
  .st0 {
    fill: #ffffff;
  }
              </style>-->
              <g>
                <path
                  class="st0"
                  d="M90.78,314.28h9.02v1.9l-5.44,6.27h5.62v2.39l-9.39-0.02v-1.9l5.44-6.27l-5.25-0.02V314.28z"
                />
                <path
                  class="st0"
                  d="M117.92,310.25v14.58h-3.01v-1.55c-0.38,0.55-0.85,0.96-1.42,1.25c-0.56,0.28-1.21,0.42-1.93,0.42
              		c-1,0-1.87-0.23-2.62-0.68c-0.76-0.46-1.34-1.09-1.75-1.92c-0.41-0.83-0.62-1.77-0.62-2.85c0-1.06,0.2-2,0.61-2.81
              		c0.41-0.82,0.98-1.44,1.73-1.89c0.75-0.45,1.6-0.67,2.57-0.67c1.49,0,2.63,0.56,3.42,1.67v-5.56H117.92z M114.18,321.7
              		c0.49-0.54,0.74-1.25,0.74-2.11c0-0.87-0.25-1.57-0.74-2.12c-0.49-0.54-1.12-0.82-1.9-0.82c-0.79,0-1.42,0.27-1.92,0.82
              		c-0.49,0.55-0.74,1.25-0.76,2.12c0.01,0.86,0.27,1.57,0.76,2.11c0.49,0.54,1.13,0.82,1.92,0.82
              		C113.05,322.51,113.69,322.24,114.18,321.7z"
                />
                <path
                  class="st0"
                  d="M130.91,314.67c0.59-0.34,1.28-0.52,2.06-0.53v2.85c-0.11-0.01-0.26-0.02-0.47-0.02
              		c-0.93,0-1.67,0.25-2.21,0.76c-0.54,0.5-0.82,1.18-0.82,2.01v5.09h-3.03v-10.57h3.03v1.9
              		C129.84,315.51,130.32,315.01,130.91,314.67z"
                />
                <path
                  class="st0"
                  d="M147.86,314.83c0.86,0.45,1.52,1.07,1.99,1.89c0.47,0.81,0.71,1.76,0.71,2.83c0,1.07-0.24,2.01-0.71,2.82
              		c-0.47,0.82-1.14,1.45-1.99,1.91c-0.86,0.45-1.84,0.68-2.96,0.68c-1.13,0-2.12-0.23-2.98-0.68c-0.86-0.46-1.52-1.09-2-1.91
              		c-0.47-0.82-0.71-1.76-0.71-2.82c0-1.07,0.24-2.01,0.71-2.83c0.47-0.82,1.14-1.44,2-1.89c0.86-0.44,1.85-0.67,2.98-0.67
              		C146.01,314.16,147,314.39,147.86,314.83z M142.98,317.48c-0.49,0.54-0.74,1.24-0.74,2.11c0,0.86,0.24,1.56,0.74,2.1
              		c0.49,0.54,1.13,0.81,1.92,0.81c0.77,0,1.41-0.27,1.89-0.81c0.49-0.54,0.74-1.24,0.74-2.1c0-0.87-0.25-1.57-0.74-2.11
              		c-0.49-0.54-1.12-0.81-1.89-0.81C144.11,316.67,143.48,316.94,142.98,317.48z"
                />
                <path
                  class="st0"
                  d="M156.2,314.28l3.09-0.02l2.36,7.57l2.28-7.57h2.97l2.32,7.57l2.32-7.57h2.99l-3.85,10.57h-3.03l-2.28-6.98
              		l-2.26,6.98h-3.03L156.2,314.28z"
                />
                <path
                  class="st0"
                  d="M189.42,315.63c0.89,0.98,1.33,2.35,1.33,4.11c0,0.32,0,0.56-0.02,0.73h-7.58c0.17,0.67,0.5,1.19,0.98,1.56
              		c0.48,0.37,1.07,0.56,1.75,0.56c0.5,0,0.98-0.09,1.43-0.28s0.87-0.47,1.24-0.83l1.59,1.61c-0.54,0.6-1.19,1.07-1.95,1.38
              		c-0.77,0.32-1.62,0.48-2.56,0.48c-1.11,0-2.08-0.23-2.92-0.67c-0.83-0.45-1.48-1.07-1.93-1.89c-0.45-0.81-0.68-1.75-0.68-2.81
              		c0-1.07,0.23-2.02,0.69-2.84c0.46-0.82,1.1-1.45,1.93-1.91c0.83-0.45,1.77-0.68,2.83-0.68
              		C187.24,314.16,188.53,314.65,189.42,315.63z M187.9,318.68c-0.03-0.7-0.25-1.25-0.67-1.67c-0.42-0.42-0.98-0.63-1.67-0.63
              		c-0.65,0-1.2,0.21-1.64,0.62c-0.44,0.41-0.72,0.97-0.83,1.68H187.9z"
                />
                <path
                  class="st0"
                  d="M206.82,314.28l3.09-0.02l2.36,7.57l2.28-7.57h2.97l2.32,7.57l2.32-7.57h2.99l-3.85,10.57h-3.03l-2.28-6.98
              		l-2.26,6.98h-3.03L206.82,314.28z"
                />
                <path
                  class="st0"
                  d="M240.03,315.63c0.89,0.98,1.33,2.35,1.33,4.11c0,0.32,0,0.56-0.02,0.73h-7.58c0.17,0.67,0.5,1.19,0.98,1.56
              		c0.48,0.37,1.07,0.56,1.75,0.56c0.5,0,0.98-0.09,1.43-0.28s0.87-0.47,1.24-0.83l1.59,1.61c-0.25,0.29-0.54,0.54-0.86,0.76
              		c-0.47,0.45-0.85,0.94-1.15,1.48c-0.3,0.54-0.44,1-0.44,1.39c0,0.41,0.16,0.61,0.47,0.61c0.21,0,0.41-0.05,0.59-0.15l0.55,1.73
              		c-0.63,0.27-1.22,0.41-1.79,0.41c-0.65,0-1.18-0.18-1.58-0.54c-0.4-0.36-0.6-0.88-0.6-1.56c0-0.79,0.32-1.54,0.96-2.28l-0.67,0.02
              		c-1.11,0-2.08-0.23-2.92-0.67c-0.83-0.45-1.48-1.07-1.93-1.89c-0.45-0.81-0.68-1.75-0.68-2.81c0-1.07,0.23-2.02,0.69-2.84
              		c0.46-0.82,1.1-1.45,1.93-1.91c0.83-0.45,1.77-0.68,2.83-0.68C237.86,314.16,239.15,314.65,240.03,315.63z M238.51,318.68
              		c-0.03-0.7-0.25-1.25-0.67-1.67c-0.42-0.42-0.98-0.63-1.67-0.63c-0.65,0-1.2,0.21-1.64,0.62c-0.44,0.41-0.72,0.97-0.83,1.68H238.51
              		z"
                />
                <path
                  class="st0"
                  d="M259.28,310.25v14.58h-3.01v-1.55c-0.38,0.55-0.85,0.96-1.42,1.25c-0.56,0.28-1.21,0.42-1.93,0.42
              		c-1,0-1.87-0.23-2.62-0.68c-0.76-0.46-1.34-1.09-1.75-1.92c-0.41-0.83-0.62-1.77-0.62-2.85c0-1.06,0.2-2,0.61-2.81
              		c0.41-0.82,0.98-1.44,1.73-1.89c0.75-0.45,1.6-0.67,2.57-0.67c1.49,0,2.63,0.56,3.42,1.67v-5.56H259.28z M255.54,321.7
              		c0.49-0.54,0.74-1.25,0.74-2.11c0-0.87-0.25-1.57-0.74-2.12c-0.49-0.54-1.12-0.82-1.9-0.82c-0.79,0-1.42,0.27-1.92,0.82
              		c-0.49,0.55-0.74,1.25-0.76,2.12c0.01,0.86,0.27,1.57,0.76,2.11c0.49,0.54,1.13,0.82,1.92,0.82
              		C254.41,322.51,255.05,322.24,255.54,321.7z"
                />
                <path class="st0" d="M267.91,310.25h3.03v14.58h-3.03V310.25z" />
                <path
                  class="st0"
                  d="M282.14,310.03c0.31,0.31,0.46,0.72,0.46,1.22c0,0.5-0.15,0.9-0.46,1.22c-0.31,0.31-0.7,0.47-1.19,0.47
              		c-0.47,0-0.86-0.16-1.17-0.48c-0.31-0.32-0.46-0.72-0.46-1.21c0-0.5,0.15-0.91,0.46-1.22c0.31-0.32,0.7-0.47,1.17-0.47
              		C281.44,309.56,281.84,309.72,282.14,310.03z M279.46,314.26h3.03v10.57h-3.03V314.26z"
                />
                <path
                  class="st0"
                  d="M300.4,315.24c0.7,0.73,1.05,1.72,1.05,2.95v6.64h-3.02v-5.76c0-0.67-0.19-1.19-0.56-1.58
              		c-0.37-0.38-0.88-0.58-1.52-0.58c-0.75,0.01-1.34,0.27-1.77,0.77c-0.43,0.51-0.65,1.15-0.65,1.94v5.21h-3.03v-10.57h3.03v1.85
              		c0.73-1.29,1.95-1.94,3.65-1.97C298.76,314.14,299.7,314.51,300.4,315.24z"
                />
                <path
                  class="st0"
                  d="M310.63,328.78c-0.56,0-1.07-0.09-1.53-0.25c-0.46-0.16-0.9-0.42-1.34-0.77l1.28-2.18
              		c0.46,0.38,0.92,0.57,1.37,0.57c0.64,0,1.11-0.32,1.4-0.95l0.3-0.59l-4.38-10.35h3.13l2.77,7.27l2.49-7.27h3.03l-4.64,11.75
              		C313.76,327.86,312.47,328.78,310.63,328.78z"
                />
              </g>
              <g>
                <path
                  class="st0"
                  d="M209,134.38c-19.73,0-35.78,12.29-35.78,27.4c0,15.11,16.05,27.39,35.78,27.39
              		c19.73,0,35.78-12.29,35.78-27.39C244.78,146.67,228.72,134.38,209,134.38z M209,177.62c-13.13,0-24.22-7.25-24.22-15.84
              		c0-8.59,11.09-15.84,24.22-15.84c13.13,0,24.22,7.25,24.22,15.84C233.22,170.37,222.13,177.62,209,177.62z"
                />
                <path
                  class="st0"
                  d="M184.82,133.5c4.2,0,7.62-3.42,7.62-7.61c0-4.2-3.42-7.62-7.62-7.62c-4.2,0-7.62,3.42-7.62,7.62
              		C177.21,130.08,180.62,133.5,184.82,133.5z"
                />
                <path
                  class="st0"
                  d="M233.17,133.5c4.2,0,7.62-3.42,7.62-7.61c0-4.2-3.42-7.62-7.62-7.62c-4.2,0-7.62,3.42-7.62,7.62
              		C225.56,130.08,228.97,133.5,233.17,133.5z"
                />
                <path
                  class="st0"
                  d="M201.62,150.48c-2.6,0-4.71,2.12-4.71,4.73v13.14c0,2.61,2.11,4.73,4.71,4.73s4.71-2.12,4.71-4.73v-13.14
              		C206.33,152.6,204.21,150.48,201.62,150.48z"
                />
                <path
                  class="st0"
                  d="M216.47,150.48c-2.6,0-4.71,2.12-4.71,4.73v13.14c0,2.61,2.11,4.73,4.71,4.73c2.6,0,4.71-2.12,4.71-4.73
              		v-13.14C221.18,152.6,219.07,150.48,216.47,150.48z"
                />
                <path
                  class="st0"
                  d="M321.73,189.99c-1.44-2.46-4.6-3.28-7.05-1.84c-1.56,0.91-3.21,1.52-4.89,1.84c4.1-4.87,4.92-11.99,1.52-17.79
              		c-4.31-7.36-13.8-9.83-21.16-5.52c-7.36,4.31-9.83,13.8-5.52,21.16c0.13,0.23,0.27,0.45,0.42,0.68c0.64,1.02,1.34,1.98,2.1,2.88
              		c-5.48,1.1-11.4-0.9-15.16-5.27c13.76-15.21,22.15-35.37,22.15-57.45c0-14.49-3.63-28.14-10-40.12l-0.25-4.95
              		c-1.47-28.55-10.42-39.5-11.44-40.65l-2.25-2.55l-3.31,0.76c-0.52,0.12-11.45,2.75-18.45,11.73c-11.96-6.34-25.58-9.95-40.03-9.95
              		c-15.4,0-29.85,4.1-42.35,11.24c-6.91-10.03-18.86-12.89-19.4-13.01l-3.31-0.76l-2.25,2.55c-1.02,1.15-9.97,12.1-11.44,40.65
              		l-0.66,12.82c-4.06,9.96-6.32,20.85-6.32,32.25c0,47.27,38.46,85.73,85.73,85.73c21.48,0,41.13-7.96,56.19-21.07
              		c3.34,3.71,7.67,6.42,12.61,7.76c6.75,1.84,13.74,0.94,19.68-2.54l0.01-0.01c7.22,3.02,15.73,2.73,22.99-1.52
              		C322.35,195.61,323.17,192.45,321.73,189.99z M258.55,58.59c2.27-2.39,5.03-3.97,7.2-4.95c1.52,2.99,3.62,8.2,5.1,16.2
              		c-0.45-0.4-0.91-0.82-1.36-1.22c-2.28-2.32-4.7-4.51-7.23-6.56C260.97,60.85,259.71,59.68,258.55,58.59z M147.78,53.63
              		c2.17,0.98,4.93,2.56,7.21,4.95c-3.64,3.45-8.19,7.57-12.31,11.25C144.17,61.81,146.27,56.6,147.78,53.63z M208.41,203.01
              		c-40.98,0-74.33-33.34-74.33-74.33c0-27.94,15.5-52.31,38.34-65.01l7.09,13.21c0,0,9.58-12.81,8.5-16.66l13.95,18.48l4.8-17.71
              		l33.97,30.4l-2.66-30.85c6.02,2.63,11.62,6.04,16.68,10.09c2.25,2.07,4.62,4.22,6.91,6.27c13.02,13.4,21.07,31.66,21.07,51.77
              		C282.73,169.67,249.39,203.01,208.41,203.01z M300.58,184.47c-2.45,1.44-5.62,0.61-7.05-1.84s-0.61-5.62,1.84-7.05
              		c2.45-1.44,5.62-0.61,7.05,1.84C303.85,179.87,303.03,183.03,300.58,184.47z"
                />
              </g>
              <g>
                <path
                  class="st0"
                  d="M19.59,252.73h15.12v5.26c4.12-3.95,8.74-5.93,13.86-5.93c6.35,0,11.19,2.67,14.53,8.02
              		c3.4-5.4,8.24-8.1,14.53-8.1c2.01,0,3.9,0.29,5.68,0.88c1.78,0.58,3.31,1.5,4.59,2.75c1.28,1.25,2.3,2.88,3.05,4.88
              		c0.75,2.01,1.13,4.43,1.13,7.27v27.81H76.97v-21.13c0-2.17-0.16-3.95-0.46-5.35c-0.31-1.39-0.75-2.48-1.34-3.25
              		c-0.59-0.78-1.27-1.31-2.04-1.59c-0.78-0.28-1.62-0.42-2.5-0.42c-4.85,0-7.27,3.54-7.27,10.61v21.13H48.24v-21.13
              		c0-2.17-0.14-3.97-0.42-5.39c-0.28-1.42-0.68-2.55-1.21-3.38c-0.53-0.83-1.21-1.41-2.05-1.71c-0.83-0.31-1.81-0.46-2.92-0.46
              		c-0.95,0-1.84,0.14-2.67,0.42c-0.83,0.28-1.57,0.82-2.21,1.63c-0.64,0.81-1.14,1.92-1.51,3.34c-0.36,1.42-0.54,3.27-0.54,5.56
              		v21.13H19.59V252.73z"
                />
                <path
                  class="st0"
                  d="M133,252.73h15.2v42.85H133v-4.76c-3.23,4.07-7.6,6.1-13.11,6.1c-3.12,0-5.99-0.57-8.6-1.71
              		c-2.62-1.14-4.9-2.74-6.85-4.8c-1.95-2.06-3.46-4.48-4.55-7.26c-1.09-2.78-1.63-5.82-1.63-9.11c0-3.06,0.53-5.97,1.59-8.73
              		c1.06-2.75,2.53-5.16,4.43-7.22c1.89-2.06,4.14-3.69,6.76-4.89c2.61-1.19,5.51-1.79,8.68-1.79c5.34,0,9.77,1.87,13.28,5.59V252.73z
              		 M113.96,274.03c0,1.4,0.25,2.69,0.75,3.89c0.5,1.2,1.18,2.24,2.04,3.13c0.86,0.89,1.89,1.59,3.09,2.09s2.49,0.75,3.89,0.75
              		c1.33,0,2.6-0.25,3.8-0.75c1.19-0.5,2.23-1.19,3.09-2.09s1.56-1.92,2.09-3.09c0.53-1.17,0.79-2.42,0.79-3.76
              		c0-1.33-0.26-2.6-0.79-3.8c-0.53-1.19-1.22-2.24-2.09-3.13c-0.86-0.89-1.89-1.58-3.09-2.09c-1.2-0.5-2.47-0.75-3.8-0.75
              		c-1.4,0-2.69,0.25-3.89,0.75c-1.2,0.5-2.23,1.2-3.09,2.09c-0.86,0.89-1.54,1.91-2.04,3.05
              		C114.21,271.45,113.96,272.69,113.96,274.03z"
                />
                <path
                  class="st0"
                  d="M172.84,265.34v30.23h-15.12v-30.23h-5.01v-12.61h5.01v-12.86h15.12v12.86h8.6v12.61H172.84z"
                />
                <path
                  class="st0"
                  d="M203.73,265.34v30.23h-15.12v-30.23h-5.01v-12.61h5.01v-12.86h15.12v12.86h8.6v12.61H203.73z"
                />
                <path
                  class="st0"
                  d="M217.43,226.26h15.12v31.9c2.06-2.5,4.15-4.19,6.27-5.05c2.12-0.86,4.59-1.3,7.43-1.3
              		c5.4,0,9.48,1.49,12.23,4.47c2.76,2.98,4.14,7,4.14,12.07v27.22h-15.12v-21.63c0-2.17-0.17-3.92-0.5-5.26
              		c-0.34-1.33-0.89-2.37-1.67-3.09c-1.34-1.17-2.96-1.75-4.85-1.75c-2.56,0-4.52,0.76-5.89,2.29c-1.37,1.54-2.05,3.72-2.05,6.56
              		v22.88h-15.12V226.26z"
                />
                <path
                  class="st0"
                  d="M269.37,236.28c0-1.17,0.23-2.27,0.67-3.3c0.44-1.03,1.06-1.93,1.84-2.71c0.78-0.78,1.68-1.39,2.71-1.84
              		c1.03-0.45,2.13-0.67,3.3-0.67c1.17,0,2.27,0.23,3.3,0.67c1.03,0.45,1.93,1.06,2.71,1.84c0.78,0.78,1.39,1.68,1.84,2.71
              		c0.45,1.03,0.67,2.13,0.67,3.3s-0.23,2.27-0.67,3.3c-0.45,1.03-1.06,1.93-1.84,2.71c-0.78,0.78-1.68,1.4-2.71,1.84
              		c-1.03,0.45-2.13,0.67-3.3,0.67c-1.17,0-2.27-0.23-3.3-0.67c-1.03-0.44-1.93-1.06-2.71-1.84c-0.78-0.78-1.4-1.68-1.84-2.71
              		C269.6,238.55,269.37,237.45,269.37,236.28z M285.49,252.73v42.85h-15.12v-42.85H285.49z"
                />
                <path
                  class="st0"
                  d="M326.41,252.73h15.2v42.85h-15.2v-4.76c-3.23,4.07-7.6,6.1-13.11,6.1c-3.12,0-5.99-0.57-8.6-1.71
              		c-2.62-1.14-4.9-2.74-6.85-4.8c-1.95-2.06-3.46-4.48-4.55-7.26c-1.09-2.78-1.63-5.82-1.63-9.11c0-3.06,0.53-5.97,1.59-8.73
              		c1.06-2.75,2.53-5.16,4.43-7.22c1.89-2.06,4.14-3.69,6.76-4.89c2.61-1.19,5.51-1.79,8.68-1.79c5.34,0,9.77,1.87,13.28,5.59V252.73z
              		 M307.37,274.03c0,1.4,0.25,2.69,0.75,3.89c0.5,1.2,1.18,2.24,2.04,3.13s1.89,1.59,3.09,2.09c1.2,0.5,2.49,0.75,3.89,0.75
              		c1.33,0,2.6-0.25,3.8-0.75c1.19-0.5,2.23-1.19,3.09-2.09c0.86-0.89,1.56-1.92,2.09-3.09c0.53-1.17,0.79-2.42,0.79-3.76
              		c0-1.33-0.26-2.6-0.79-3.8c-0.53-1.19-1.22-2.24-2.09-3.13c-0.86-0.89-1.89-1.58-3.09-2.09c-1.2-0.5-2.47-0.75-3.8-0.75
              		c-1.4,0-2.69,0.25-3.89,0.75c-1.2,0.5-2.23,1.2-3.09,2.09c-0.86,0.89-1.54,1.91-2.04,3.05
              		C307.62,271.45,307.37,272.69,307.37,274.03z"
                />
                <path
                  class="st0"
                  d="M377.77,263.76c-2.78-1.44-5.51-2.17-8.18-2.17c-1.39,0-2.52,0.28-3.38,0.83c-0.86,0.56-1.3,1.31-1.3,2.25
              		c0,0.5,0.07,0.91,0.21,1.21c0.14,0.31,0.44,0.6,0.92,0.88c0.47,0.28,1.17,0.53,2.09,0.75c0.92,0.22,2.13,0.5,3.64,0.83
              		c4.17,0.83,7.29,2.32,9.35,4.47c2.06,2.14,3.09,4.88,3.09,8.23c0,2.5-0.5,4.76-1.5,6.76c-1,2.01-2.39,3.69-4.17,5.05
              		c-1.78,1.37-3.92,2.42-6.43,3.17c-2.5,0.75-5.26,1.13-8.27,1.13c-5.79,0-11.5-1.65-17.12-4.93l5.51-10.69
              		c4.23,2.9,8.24,4.34,12.03,4.34c1.39,0,2.53-0.3,3.43-0.92c0.89-0.61,1.33-1.39,1.33-2.34c0-0.56-0.07-1.02-0.21-1.38
              		c-0.14-0.36-0.43-0.7-0.88-1c-0.45-0.3-1.1-0.58-1.96-0.83c-0.86-0.25-1.99-0.51-3.38-0.79c-4.68-0.95-7.95-2.35-9.82-4.22
              		c-1.87-1.87-2.8-4.44-2.8-7.72c0-2.39,0.45-4.55,1.34-6.48c0.89-1.92,2.17-3.55,3.84-4.88c1.67-1.33,3.69-2.37,6.06-3.09
              		c2.37-0.72,4.99-1.08,7.89-1.08c4.73,0,9.32,0.92,13.78,2.75L377.77,263.76z"
                />
              </g>
            </svg>
          </div>
          <div class="col-6" data-aos="fade-up">
            <svg
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="0 0 396.46 376.15"
              style="enable-background:new 0 0 396.46 376.15;"
              xml:space="preserve"
            >
              <!-- <style type="text/css">
  .st0 {
    fill: #ffffff;
  }
              </style>-->
              <g>
                <path
                  class="st0"
                  d="M75.24,327.58v4.29H62.98v-3.06l5.79-7.97h-5.49v-4.29h11.65v3.06l-5.79,7.97H75.24z"
                />
                <path
                  class="st0"
                  d="M96.77,310.42v21.45h-4.6v-1.44c-1.01,1.16-2.51,1.87-4.57,1.87c-4.02,0-7.32-3.52-7.32-8.09
              		c0-4.57,3.31-8.09,7.32-8.09c2.05,0,3.56,0.7,4.57,1.87v-7.57H96.77z M92.17,324.21c0-2.3-1.53-3.74-3.65-3.74
              		c-2.12,0-3.65,1.44-3.65,3.74c0,2.3,1.53,3.74,3.65,3.74C90.64,327.95,92.17,326.51,92.17,324.21z"
                />
                <path
                  class="st0"
                  d="M113.29,316.23v5.21c-1.9-0.3-4.6,0.46-4.6,3.49v6.93h-4.6v-15.33h4.6v2.73
              		C109.31,317.22,111.36,316.23,113.29,316.23z"
                />
                <path
                  class="st0"
                  d="M118.18,324.21c0-4.57,3.62-8.09,8.12-8.09c4.51,0,8.12,3.52,8.12,8.09c0,4.57-3.62,8.09-8.12,8.09
              		C121.8,332.3,118.18,328.78,118.18,324.21z M129.83,324.21c0-2.17-1.53-3.61-3.52-3.61s-3.52,1.44-3.52,3.61
              		c0,2.17,1.53,3.61,3.52,3.61S129.83,326.38,129.83,324.21z"
                />
                <path
                  class="st0"
                  d="M162.15,316.54l-4.9,15.33h-4.29l-2.45-8.18l-2.45,8.18h-4.29l-4.9-15.33h4.9l2.21,8.21l2.39-8.21h4.29
              		l2.39,8.21l2.21-8.21H162.15z"
                />
                <path
                  class="st0"
                  d="M175.11,328.19c1.26,0,2.33-0.48,2.94-1.16l3.68,2.12c-1.5,2.08-3.77,3.16-6.68,3.16
              		c-5.24,0-8.49-3.52-8.49-8.09c0-4.57,3.31-8.09,8.15-8.09c4.48,0,7.79,3.46,7.79,8.09c0,0.65-0.06,1.26-0.18,1.84h-10.88
              		C172.02,327.64,173.43,328.19,175.11,328.19z M177.93,322.61c-0.49-1.78-1.87-2.42-3.25-2.42c-1.75,0-2.91,0.86-3.34,2.42H177.93z"
                />
                <path
                  class="st0"
                  d="M222.46,316.54l-4.9,15.33h-4.29l-2.45-8.18l-2.45,8.18h-4.29l-4.9-15.33h4.9l2.21,8.21l2.39-8.21h4.29
              		l2.39,8.21l2.21-8.21H222.46z"
                />
                <path
                  class="st0"
                  d="M235.43,328.19c1.26,0,2.33-0.48,2.94-1.16l3.68,2.12c-0.34,0.45-0.71,0.86-1.1,1.22
              		c-1.99,2.15-2.27,3.59-2.27,4.11c0,0.49,0.22,0.8,0.67,0.8c0.19,0.03,0.43-0.03,0.71-0.12v2.76c-0.83,0.34-1.59,0.52-2.7,0.52
              		c-1.69,0-3.07-0.86-3.07-2.79c0-1.04,0.64-2.27,2.05-3.37c-0.31,0.03-0.64,0.03-0.98,0.03c-5.24,0-8.49-3.52-8.49-8.09
              		c0-4.57,3.31-8.09,8.15-8.09c4.47,0,7.78,3.46,7.78,8.09c0,0.65-0.06,1.26-0.18,1.84h-10.88
              		C232.33,327.64,233.74,328.19,235.43,328.19z M238.25,322.61c-0.49-1.78-1.87-2.42-3.25-2.42c-1.75,0-2.91,0.86-3.34,2.42H238.25z"
                />
                <path
                  class="st0"
                  d="M264.95,310.42v21.45h-4.6v-1.44c-1.01,1.16-2.51,1.87-4.57,1.87c-4.02,0-7.32-3.52-7.32-8.09
              		c0-4.57,3.31-8.09,7.32-8.09c2.05,0,3.56,0.7,4.57,1.87v-7.57H264.95z M260.35,324.21c0-2.3-1.53-3.74-3.65-3.74
              		c-2.12,0-3.65,1.44-3.65,3.74c0,2.3,1.53,3.74,3.65,3.74C258.82,327.95,260.35,326.51,260.35,324.21z"
                />
                <path class="st0" d="M272.28,309.49h4.6v22.38h-4.6V309.49z" />
                <path
                  class="st0"
                  d="M283.76,312.44c0-1.5,1.26-2.76,2.76-2.76c1.5,0,2.76,1.26,2.76,2.76c0,1.5-1.26,2.76-2.76,2.76
              		C285.02,315.2,283.76,313.94,283.76,312.44z M284.23,316.54h4.6v15.33h-4.6V316.54z"
                />
                <path
                  class="st0"
                  d="M310.88,322.46v9.41h-4.6v-8.74c0-1.9-1.2-2.79-2.67-2.79c-1.69,0-2.85,0.99-2.85,3.16v8.37h-4.6v-15.33h4.6
              		v1.44c0.83-1.13,2.36-1.87,4.38-1.87C308.24,316.12,310.88,318.32,310.88,322.46z"
                />
                <path
                  class="st0"
                  d="M332.25,316.54l-5.24,14.87c-1.72,4.88-4.45,6.8-8.74,6.59v-4.29c2.15,0,3.16-0.67,3.83-2.54l-6.1-14.62h5.06
              		l3.4,9.38l2.88-9.38H332.25z"
                />
              </g>
              <g>
                <path
                  class="st0"
                  d="M17.98,257.3H33.2v5.3c4.15-3.98,8.8-5.97,13.96-5.97c6.39,0,11.27,2.69,14.64,8.07
              		c3.42-5.44,8.3-8.16,14.64-8.16c2.02,0,3.92,0.29,5.72,0.88c1.79,0.59,3.33,1.52,4.62,2.78c1.29,1.26,2.31,2.9,3.07,4.92
              		c0.76,2.02,1.14,4.46,1.14,7.32v28H75.77v-21.28c0-2.18-0.16-3.98-0.46-5.38c-0.31-1.4-0.76-2.49-1.35-3.28
              		c-0.59-0.79-1.28-1.32-2.06-1.6c-0.79-0.28-1.63-0.42-2.52-0.42c-4.88,0-7.32,3.56-7.32,10.68v21.28H46.83v-21.28
              		c0-2.18-0.14-3.99-0.42-5.42c-0.28-1.43-0.69-2.57-1.22-3.41c-0.54-0.84-1.22-1.41-2.06-1.72s-1.82-0.46-2.94-0.46
              		c-0.95,0-1.85,0.14-2.69,0.42s-1.58,0.83-2.23,1.64c-0.65,0.81-1.15,1.93-1.52,3.36c-0.36,1.43-0.55,3.3-0.55,5.6v21.28H17.98
              		V257.3z"
                />
                <path
                  class="st0"
                  d="M132.2,257.3h15.31v43.15H132.2v-4.79c-3.25,4.1-7.65,6.14-13.21,6.14c-3.14,0-6.03-0.57-8.66-1.72
              		c-2.64-1.15-4.94-2.76-6.9-4.84s-3.49-4.51-4.58-7.32c-1.1-2.8-1.64-5.86-1.64-9.17c0-3.08,0.53-6.02,1.6-8.79
              		c1.06-2.77,2.55-5.2,4.46-7.28c1.9-2.07,4.17-3.71,6.81-4.92c2.63-1.21,5.55-1.81,8.75-1.81c5.38,0,9.84,1.87,13.37,5.63V257.3z
              		 M113.02,278.74c0,1.41,0.25,2.71,0.76,3.91c0.5,1.21,1.19,2.26,2.06,3.16c0.87,0.9,1.9,1.59,3.11,2.1
              		c1.21,0.51,2.51,0.76,3.91,0.76c1.34,0,2.62-0.26,3.83-0.76c1.2-0.5,2.24-1.2,3.11-2.1c0.87-0.9,1.57-1.94,2.1-3.11
              		c0.53-1.18,0.8-2.44,0.8-3.79c0-1.34-0.27-2.62-0.8-3.83c-0.53-1.21-1.23-2.26-2.1-3.16c-0.87-0.89-1.91-1.6-3.11-2.1
              		c-1.21-0.5-2.48-0.75-3.83-0.75c-1.41,0-2.71,0.25-3.91,0.75c-1.21,0.5-2.24,1.21-3.11,2.1c-0.87,0.9-1.56,1.92-2.06,3.07
              		C113.27,276.15,113.02,277.4,113.02,278.74z"
                />
                <path
                  class="st0"
                  d="M172.32,270v30.44H157.1V270h-5.05v-12.7h5.05v-12.95h15.22v12.95h8.66V270H172.32z"
                />
                <path
                  class="st0"
                  d="M203.44,270v30.44h-15.22V270h-5.05v-12.7h5.05v-12.95h15.22v12.95h8.66V270H203.44z"
                />
                <path
                  class="st0"
                  d="M217.23,230.64h15.22v32.13c2.07-2.52,4.18-4.22,6.31-5.09c2.13-0.87,4.62-1.3,7.48-1.3
              		c5.44,0,9.55,1.51,12.32,4.5c2.78,3,4.16,7.05,4.16,12.16v27.42h-15.22v-21.78c0-2.19-0.17-3.95-0.5-5.3
              		c-0.34-1.35-0.9-2.38-1.68-3.11c-1.35-1.17-2.98-1.76-4.88-1.76c-2.58,0-4.56,0.77-5.93,2.31c-1.38,1.55-2.06,3.74-2.06,6.6v23.05
              		h-15.22V230.64z"
                />
                <path
                  class="st0"
                  d="M269.55,240.73c0-1.18,0.23-2.29,0.68-3.32c0.44-1.04,1.06-1.95,1.85-2.73c0.78-0.79,1.7-1.4,2.73-1.86
              		c1.04-0.44,2.15-0.67,3.32-0.67c1.18,0,2.29,0.23,3.32,0.67c1.03,0.45,1.95,1.07,2.73,1.86c0.79,0.78,1.4,1.69,1.85,2.73
              		c0.45,1.04,0.68,2.15,0.68,3.32c0,1.17-0.23,2.29-0.68,3.32c-0.45,1.04-1.06,1.95-1.85,2.73c-0.78,0.79-1.7,1.4-2.73,1.85
              		c-1.04,0.45-2.15,0.67-3.32,0.67c-1.18,0-2.29-0.22-3.32-0.67c-1.03-0.45-1.95-1.06-2.73-1.85c-0.79-0.78-1.41-1.69-1.85-2.73
              		C269.77,243.01,269.55,241.9,269.55,240.73z M285.78,257.3v43.15h-15.22V257.3H285.78z"
                />
                <path
                  class="st0"
                  d="M327,257.3h15.31v43.15H327v-4.79c-3.25,4.1-7.65,6.14-13.21,6.14c-3.14,0-6.03-0.57-8.66-1.72
              		c-2.64-1.15-4.94-2.76-6.9-4.84c-1.96-2.07-3.49-4.51-4.58-7.32c-1.1-2.8-1.64-5.86-1.64-9.17c0-3.08,0.53-6.02,1.6-8.79
              		c1.06-2.77,2.55-5.2,4.46-7.28c1.9-2.07,4.17-3.71,6.81-4.92c2.63-1.21,5.55-1.81,8.75-1.81c5.38,0,9.84,1.87,13.37,5.63V257.3z
              		 M307.82,278.74c0,1.41,0.25,2.71,0.76,3.91c0.5,1.21,1.19,2.26,2.06,3.16c0.87,0.9,1.9,1.59,3.11,2.1
              		c1.21,0.51,2.51,0.76,3.91,0.76c1.34,0,2.62-0.26,3.83-0.76c1.2-0.5,2.24-1.2,3.11-2.1c0.87-0.9,1.57-1.94,2.1-3.11
              		c0.53-1.18,0.8-2.44,0.8-3.79c0-1.34-0.27-2.62-0.8-3.83s-1.23-2.26-2.1-3.16c-0.87-0.89-1.91-1.6-3.11-2.1
              		c-1.21-0.5-2.48-0.75-3.83-0.75c-1.41,0-2.71,0.25-3.91,0.75c-1.21,0.5-2.24,1.21-3.11,2.1c-0.87,0.9-1.56,1.92-2.06,3.07
              		C308.07,276.15,307.82,277.4,307.82,278.74z"
                />
                <path
                  class="st0"
                  d="M378.73,268.4c-2.8-1.46-5.55-2.18-8.24-2.18c-1.4,0-2.54,0.28-3.41,0.84s-1.3,1.31-1.3,2.27
              		c0,0.5,0.07,0.91,0.21,1.22c0.14,0.31,0.44,0.6,0.92,0.88c0.48,0.29,1.18,0.54,2.1,0.76c0.93,0.22,2.15,0.5,3.66,0.84
              		c4.2,0.84,7.34,2.34,9.42,4.5c2.08,2.16,3.11,4.92,3.11,8.29c0,2.52-0.5,4.79-1.51,6.81c-1.01,2.02-2.41,3.71-4.2,5.08
              		c-1.8,1.38-3.95,2.44-6.48,3.2c-2.52,0.76-5.3,1.14-8.33,1.14c-5.83,0-11.58-1.66-17.24-4.97l5.55-10.77
              		c4.26,2.92,8.3,4.37,12.11,4.37c1.4,0,2.55-0.3,3.45-0.92c0.89-0.62,1.34-1.4,1.34-2.36c0-0.56-0.07-1.02-0.21-1.39
              		c-0.14-0.36-0.43-0.7-0.88-1.01c-0.45-0.31-1.11-0.59-1.98-0.84s-2.01-0.52-3.41-0.8c-4.71-0.95-8.01-2.37-9.89-4.24
              		c-1.88-1.88-2.82-4.47-2.82-7.78c0-2.42,0.45-4.59,1.35-6.52c0.89-1.93,2.18-3.58,3.87-4.92c1.69-1.34,3.72-2.39,6.1-3.11
              		c2.38-0.73,5.03-1.09,7.95-1.09c4.76,0,9.39,0.92,13.88,2.77L378.73,268.4z"
                />
              </g>
              <g>
                <path
                  class="st0"
                  d="M200.14,126.95c-19.92,0-36.12,12.41-36.12,27.66c0,15.25,16.2,27.66,36.12,27.66
              		c19.92,0,36.12-12.41,36.12-27.66C236.26,139.36,220.05,126.95,200.14,126.95z M200.14,170.6c-13.26,0-24.45-7.32-24.45-15.99
              		c0-8.67,11.2-15.99,24.45-15.99c13.26,0,24.46,7.32,24.46,15.99C224.59,163.28,213.39,170.6,200.14,170.6z"
                />
                <path
                  class="st0"
                  d="M175.73,126.05c4.24,0,7.69-3.45,7.69-7.69c0-4.24-3.45-7.69-7.69-7.69c-4.24,0-7.69,3.45-7.69,7.69
              		C168.04,122.61,171.49,126.05,175.73,126.05z"
                />
                <path
                  class="st0"
                  d="M224.55,126.05c4.24,0,7.69-3.45,7.69-7.69c0-4.24-3.45-7.69-7.69-7.69c-4.24,0-7.69,3.45-7.69,7.69
              		C216.85,122.61,220.3,126.05,224.55,126.05z"
                />
                <path
                  class="st0"
                  d="M192.69,143.2c-2.62,0-4.75,2.14-4.75,4.77v13.27c0,2.63,2.13,4.77,4.75,4.77c2.62,0,4.75-2.14,4.75-4.77
              		v-13.27C197.44,145.34,195.31,143.2,192.69,143.2z"
                />
                <path
                  class="st0"
                  d="M207.68,143.2c-2.62,0-4.75,2.14-4.75,4.77v13.27c0,2.63,2.13,4.77,4.75,4.77c2.62,0,4.75-2.14,4.75-4.77
              		v-13.27C212.43,145.34,210.3,143.2,207.68,143.2z"
                />
                <path
                  class="st0"
                  d="M313.96,183.09c-1.45-2.48-4.64-3.31-7.12-1.86c-1.57,0.92-3.24,1.53-4.94,1.86
              		c4.14-4.92,4.97-12.11,1.54-17.96c-4.35-7.43-13.94-9.93-21.36-5.57c-7.43,4.35-9.93,13.94-5.57,21.36
              		c0.14,0.23,0.28,0.46,0.42,0.68c0.65,1.03,1.36,2,2.12,2.91c-5.53,1.11-11.51-0.91-15.31-5.32c13.89-15.36,22.37-35.71,22.37-58
              		c0-14.63-3.66-28.41-10.09-40.51l-0.26-5c-1.48-28.83-10.53-39.88-11.55-41.04l-2.27-2.57l-3.34,0.77
              		c-0.52,0.12-11.56,2.77-18.63,11.84c-12.07-6.4-25.83-10.05-40.42-10.05c-15.55,0-30.14,4.14-42.76,11.35
              		c-6.97-10.12-19.04-13.01-19.59-13.14l-3.34-0.77l-2.27,2.57c-1.03,1.16-10.07,12.22-11.55,41.04l-0.67,12.94
              		c-4.1,10.06-6.38,21.05-6.38,32.57c0,47.73,38.83,86.56,86.56,86.56c21.69,0,41.53-8.04,56.74-21.27
              		c3.37,3.75,7.75,6.48,12.74,7.84c6.82,1.86,13.87,0.95,19.87-2.56l0.01-0.01c7.29,3.05,15.88,2.76,23.21-1.54
              		C314.58,188.76,315.41,185.57,313.96,183.09z M250.17,50.42c2.3-2.41,5.08-4.01,7.27-5c1.53,3.02,3.65,8.28,5.15,16.35
              		c-0.45-0.4-0.92-0.82-1.38-1.24c-2.3-2.34-4.74-4.55-7.3-6.62C252.61,52.71,251.34,51.53,250.17,50.42z M138.33,45.42
              		c2.19,0.99,4.98,2.59,7.28,5c-3.68,3.48-8.27,7.64-12.43,11.35C134.68,53.68,136.81,48.42,138.33,45.42z M199.54,196.24
              		c-41.38,0-75.04-33.67-75.04-75.04c0-28.2,15.65-52.81,38.71-65.63l7.16,13.34c0,0,9.67-12.93,8.59-16.82l14.09,18.66l4.85-17.88
              		l34.3,30.7l-2.69-31.14c6.07,2.66,11.73,6.09,16.84,10.19c2.27,2.09,4.67,4.26,6.98,6.33c13.15,13.52,21.27,31.96,21.27,52.27
              		C274.58,162.57,240.92,196.24,199.54,196.24z M292.6,177.52c-2.48,1.45-5.67,0.62-7.12-1.86c-1.45-2.48-0.62-5.67,1.86-7.12
              		c2.48-1.45,5.67-0.62,7.12,1.86C295.91,172.87,295.07,176.07,292.6,177.52z"
                />
              </g>
            </svg>
          </div>
        </div>
        <img
          class="img-full lazyload pb-0 pt-0"
          src="https://ik.imagekit.io/intervi/8_i0VjD0iYB.jpg"
          data-src="https://ik.imagekit.io/intervi/8_i0VjD0iYB.jpg"
          alt="Opakowanie staku wieprzowego Exclusive"
          data-aos="fade-up"
        />
        <img
          class="img-full lazyload pt-0 pb-0"
          src="https://ik.imagekit.io/intervi/9_WoqSlw0Ch.jpg"
          data-src="https://ik.imagekit.io/intervi/9_WoqSlw0Ch.jpg"
          alt="Reklama zewnętrzna Matthias"
          data-aos="fade-up"
        />
        <img
          class="img-full lazyload pt-0 pb-0"
          src="https://ik.imagekit.io/intervi/10_LFtXRhZyg.jpg"
          data-src="https://ik.imagekit.io/intervi/10_LFtXRhZyg.jpg"
          alt="Steki wieprzowe w opakowaniu na czerwonym tle"
          data-aos="fade-up"
        />
        <img
          class="img-full lazyload pt-0"
          src="https://ik.imagekit.io/intervi/11_gR7a49ic3.jpg"
          data-src="https://ik.imagekit.io/intervi/11_gR7a49ic3.jpg"
          alt="Kiełbasy z pieczywem propozycja podania"
          data-aos="fade-up"
        />
        <img
          class="img-full lazyload"
          src="https://ik.imagekit.io/intervi/12_O8pCyY4wf.jpg"
          data-src="https://ik.imagekit.io/intervi/12_O8pCyY4wf.jpg"
          alt="Schab propozycja podania"
          data-aos="fade-up"
        />
        <img
          class="img-full lazyload"
          src="https://ik.imagekit.io/intervi/13_eL37Sv8xlI.jpg"
          data-src="https://ik.imagekit.io/intervi/13_eL37Sv8xlI.jpg"
          alt="Kiełbasy na talerzu propozycja podania"
          data-aos="fade-up"
        />
        <img
          class="img-full lazyload pb-0"
          src="https://ik.imagekit.io/intervi/14_M3jTnzoQV.jpg"
          data-src="https://ik.imagekit.io/intervi/14_M3jTnzoQV.jpg"
          alt="Grafina z telefonami"
          data-aos="fade-up"
        />
        <img
          class="img-full lazyload pt-0 pb-0"
          src="https://ik.imagekit.io/intervi/15_vt3w4-0gL.jpg"
          data-src="https://ik.imagekit.io/intervi/15_vt3w4-0gL.jpg"
          alt="Screeny strony internetowej na kopnuterze i smartfonie"
          data-aos="fade-up"
        />
        <img
          class="img-full lazyload"
          src="https://ik.imagekit.io/intervi/16_86PHbBIsUF.jpg"
          data-src="https://ik.imagekit.io/intervi/16_86PHbBIsUF.jpg"
          alt="Reklama miejska - swojskie smaki na każdy stół"
          data-aos="fade-up"
        />
      </section>

      <!-- Navigation -->
      <section class="section__project nav">
        <div class="section-box">
          <div class="title__box w-100">
            <h2>
              <router-link to="/project-janczaki" style="float: left;"
                >Previous</router-link
              >
              <router-link
                to="/project-social-monster-new"
                style="float: right;"
                >Next project</router-link
              >
            </h2>
          </div>
          <FloatingSocials :hoverColor="projects[6].dot" />
          <FloatingText />
          <FloatingContact />
          <BackToTop />
        </div>
      </section>
    </div>
  </ScrollProgressBar>
</template>

<style lang="scss" scoped>
section {
  height: 100vh;
  width: 100vw;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>

<script>
import projects from "@/assets/projects";
import ComponentMatthias from "@/components/inner-components/ComponentMatthias";
import FloatingSocials from "@/components/small-components/FloatingSocials";
import FloatingText from "@/components/small-components/FloatingText";
import CaseContact from "@/components/small-components/CaseContact";
import FloatingContact from "@/components/small-components/FloatingContact";
import BackToTop from "@/components/small-components/BackToTop";
import ScrollProgressBar from "@/components/small-components/ScrollProgressBar";
import Menu from "@/components/small-components/Menu";
import mixColor from "@/js/functions";
import AOS from "aos";
import "aos/dist/aos.css";

export default {
  name: "ProjectMatthias",
  data() {
    return {
      projects: projects,
      activeSectionTitle: 0,
      isWhite: true,
      prevBg: "",
      isScrolling: false,
      activeSection: 0,
      activeSectionMenuColor: "",
      showChild: true,
      showTeam: false,
      sections: [
        {
          absoluteIndex: 0
        }
      ]
    };
  },
  mounted() {
    this.checkMenuActive();
  },
  watch: {
    isScrolling: function() {
      if (this.isScrolling == false) {
        window.onscroll = function() {};
      } else {
        window.onscroll = function() {
          window.scrollTo(0, 0);
        };
      }
    }
  },
  methods: {
    checkMenuActive: function() {
      if (this.isScrolling == true) {
        window.onscroll = function() {
          window.scrollTo(0, 0);
        };
      } else {
        window.onscroll = function() {};
      }
    }
  },
  created() {
    setTimeout(function() {
      AOS.refresh();
    }, 1000);
    setTimeout(function() {
      mixColor();
    }, 1000);
  },
  components: {
    ScrollProgressBar,
    ComponentMatthias,
    FloatingSocials,
    FloatingText,
    CaseContact,
    FloatingContact,
    BackToTop,
    Menu
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ProjectMatthias.vue